/* 🤖 this file was generated by svg-to-ts */
export const add16X16: {
  name: 'add_16_x_16';
  data: string;
} = {
  name: 'add_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 7H9V3H7v4H3v2h4v4h2V9h4z" class="cls-1"/></svg>`,
};
export const arrowDown16X16: {
  name: 'arrow_down_16_x_16';
  data: string;
} = {
  name: 'arrow_down_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 16 16"><path d="M9 2v6.207l2.5-1.188L8.021 14 4.5 7.019 7 8.207V2z"/></svg>`,
};
export const arrowDownLeftAndArrowUpRight16X16: {
  name: 'arrow_down_left_and_arrow_up_right_16_x_16';
  data: string;
} = {
  name: 'arrow_down_left_and_arrow_up_right_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m2.007 13.171 2.247-2.276-2.284-.447 5.246-1.732-1.753 5.217-.456-2.284-2.26 2.291zM13.194 2l-2.261 2.29-.456-2.283-1.753 5.217 5.246-1.732-2.284-.447 2.247-2.276z" class="cls-1"/></svg>`,
};
export const arrowDownRectangle16X16: {
  name: 'arrow_down_rectangle_16_x_16';
  data: string;
} = {
  name: 'arrow_down_rectangle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.018 11 11 5.1 8.996 6.412 9 2H7v4.387L5 5.1zm0 0L11 5.1 8.996 6.412 9 2H7v4.387L5 5.1zM14 9v5H2V9h3.871l.512 1H3v3h10v-3H9.643l.506-1z" class="cls-1"/></svg>`,
};
export const arrowDownRightAndArrowUpLeft16X16: {
  name: 'arrow_down_right_and_arrow_up_left_16_x_16';
  data: string;
} = {
  name: 'arrow_down_right_and_arrow_up_left_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m13.171 13.933-2.276-2.247-.447 2.284-1.732-5.246 5.217 1.753-2.284.456 2.291 2.26ZM2 2.746l2.29 2.261-2.283.456 5.217 1.753L5.492 1.97l-.447 2.284-2.276-2.247Z" class="cls-1"/></svg>`,
};
export const arrowExpanderDown16X16: {
  name: 'arrow_expander_down_16_x_16';
  data: string;
} = {
  name: 'arrow_expander_down_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m3.5 4.737 1.11-.732 3.357 5.472L11.397 4l1.103.743L7.955 12z" class="cls-1"/></svg>`,
};
export const arrowExpanderLeft16X16: {
  name: 'arrow_expander_left_16_x_16';
  data: string;
} = {
  name: 'arrow_expander_left_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m11.263 3.5.732 1.11-5.472 3.357L12 11.397l-.743 1.103L4 7.955z" class="cls-1"/></svg>`,
};
export const arrowExpanderRight16X16: {
  name: 'arrow_expander_right_16_x_16';
  data: string;
} = {
  name: 'arrow_expander_right_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m4.737 12.5-.732-1.11 5.472-3.357L4 4.603 4.743 3.5 12 8.045z" class="cls-1"/></svg>`,
};
export const arrowExpanderUp16X16: {
  name: 'arrow_expander_up_16_x_16';
  data: string;
} = {
  name: 'arrow_expander_up_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m12.5 11.263-1.11.732-3.357-5.472L4.603 12 3.5 11.257 8.045 4z" class="cls-1"/></svg>`,
};
export const arrowInCircle16X16: {
  name: 'arrow_in_circle_16_x_16';
  data: string;
} = {
  name: 'arrow_in_circle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.5 5.25a3.24 3.24 0 0 0-2.738 1.513L11.236 8.5l-3.474 1.737A3.24 3.24 0 0 0 10.5 11.75a3.25 3.25 0 0 0 0-6.5" class="cls-1"/><path d="m4 6 1 2H2v1h3l-1 2 5-2.5z" class="cls-1"/></svg>`,
};
export const arrowLeftFromLine16X16: {
  name: 'arrow_left_from_line_16_x_16';
  data: string;
} = {
  name: 'arrow_left_from_line_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 14h2V2h-2ZM2 7.982 7.9 5 6.588 7.004 11 7v2H6.613L7.9 11Z" class="cls-1"/></svg>`,
};
export const arrowOutCircle16X16: {
  name: 'arrow_out_circle_16_x_16';
  data: string;
} = {
  name: 'arrow_out_circle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m9 6 1 2H7v1h3l-1 2 5-2.5z" class="cls-1"/><path d="M6 10V7h2.367A3.24 3.24 0 0 0 5.5 5.25a3.25 3.25 0 0 0 0 6.5c1.25 0 2.324-.714 2.867-1.75z" class="cls-1"/></svg>`,
};
export const arrowPartialRotateLeft16X16: {
  name: 'arrow_partial_rotate_left_16_x_16';
  data: string;
} = {
  name: 'arrow_partial_rotate_left_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 11.988a3.086 3.086 0 0 0 3.143-3.025 3.08 3.08 0 0 0-3.085-3.02v.088l.826 2.067-5.598-2.796L8.884 2.5l-.742 1.932a4.62 4.62 0 0 1 4.572 4.53A4.63 4.63 0 0 1 8 13.5Z" class="cls-1"/></svg>`,
};
export const arrowRightThin16X16: {
  name: 'arrow_right_thin_16_x_16';
  data: string;
} = {
  name: 'arrow_right_thin_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m7.831 4.386-.706 1.127 3.128 1.837H2v1.3h8.365L7.49 10.528l.768 1.085L13.875 8z" class="cls-1"/></svg>`,
};
export const arrowRightToLine16X16: {
  name: 'arrow_right_to_line_16_x_16';
  data: string;
} = {
  name: 'arrow_right_to_line_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 14h2V2h-2Zm-6.9-3 1.287-2H2V7l4.412.004L5.1 5 11 7.982Z" class="cls-1"/></svg>`,
};
export const arrowRotateRight16X16: {
  name: 'arrow_rotate_right_16_x_16';
  data: string;
} = {
  name: 'arrow_rotate_right_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.9 2.773v1.715a3.366 3.366 0 0 1 3.3 3.428 3.366 3.366 0 0 1-3.3 3.429 3.36 3.36 0 0 1-3.293-3.366h.095l2.255.901-3.05-6.107L1.85 8.88l2.108-.808A5.04 5.04 0 0 0 8.9 13.059a5.05 5.05 0 0 0 4.95-5.143A5.05 5.05 0 0 0 8.9 2.773" class="cls-1"/></svg>`,
};
export const arrowULeft16X16: {
  name: 'arrow_u_left_16_x_16';
  data: string;
} = {
  name: 'arrow_u_left_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m9.453 8.857-1.68-2.571h.908a3 3 0 0 1 0 6H3.11V14h5.571a4.714 4.714 0 0 0 0-9.429h-.908L9.453 2 2.604 5.403z" class="cls-1"/></svg>`,
};
export const arrowURight16X16: {
  name: 'arrow_u_right_16_x_16';
  data: string;
} = {
  name: 'arrow_u_right_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m6.547 8.857 1.68-2.571H7.32a3 3 0 0 0 0 6h5.571V14H7.319a4.714 4.714 0 0 1 0-9.429h.908L6.547 2l6.849 3.403z" class="cls-1"/></svg>`,
};
export const arrowUUp16X16: {
  name: 'arrow_u_up_16_x_16';
  data: string;
} = {
  name: 'arrow_u_up_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m8.857 9.453-2.571-1.68v.908a3 3 0 0 0 3 3 3 3 0 0 0 3-3V3.11H14v5.571a4.714 4.714 0 0 1-4.714 4.715A4.714 4.714 0 0 1 4.57 8.68v-.908L2 9.453l3.403-6.849Z" class="cls-1"/></svg>`,
};
export const arrowUp16X16: {
  name: 'arrow_up_16_x_16';
  data: string;
} = {
  name: 'arrow_up_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 16 16"><path d="M7 14V7.793L4.5 8.981 7.979 2 11.5 8.981 9 7.793V14z"/></svg>`,
};
export const arrowUpLeftAndArrowDownRight16X16: {
  name: 'arrow_up_left_and_arrow_down_right_16_x_16';
  data: string;
} = {
  name: 'arrow_up_left_and_arrow_down_right_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m4.195 4.977-.451 2.296L2 2l5.256 1.762-2.301.458 6.849 6.803.452-2.296L14 14l-5.256-1.762 2.301-.458z" class="cls-1"/></svg>`,
};
export const arrowUpRectangle16X16: {
  name: 'arrow_up_rectangle_16_x_16';
  data: string;
} = {
  name: 'arrow_up_rectangle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.982 2 5 7.9l2.004-1.312L7 11h2V6.613L11 7.9zm0 0L5 7.9l2.004-1.312L7 11h2V6.613L11 7.9zM14 9v5H2V9h4v1H3v3h10v-3h-3V9z" class="cls-1"/></svg>`,
};
export const arrowUpRightAndArrowDownLeft16X16: {
  name: 'arrow_up_right_and_arrow_down_left_16_x_16';
  data: string;
} = {
  name: 'arrow_up_right_and_arrow_down_left_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m11.023 4.195-2.296-.45L14 2l-1.762 5.256-.458-2.301-6.803 6.85 2.296.45L2 14l1.762-5.256.458 2.301z" class="cls-1"/></svg>`,
};
export const arrowUpRightFromSquare16X16: {
  name: 'arrow_up_right_from_square_16_x_16';
  data: string;
} = {
  name: 'arrow_up_right_from_square_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.436 10h1v3h-9V4h3v1h-2v7h7zm-3.42-6.173.298 1.296 2.92-.748L5.068 9.53l.925.926L11.13 5.33l-.52 2.532 1.31.225 1.2-5.839z" class="cls-1"/></svg>`,
};
export const arrowsMaximize16X16: {
  name: 'arrows_maximize_16_x_16';
  data: string;
} = {
  name: 'arrows_maximize_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12.26 8.735 14 14l-5.25-1.763 2.295-.457-3.03-3.022L8 8.742l-.015.016.015.014-3.023 3.023 2.296.45L2 13.985l1.762-5.243.458 2.295 3.015-3.015.007-.007L7.258 8l-.016-.015L7.227 8l-3.03-3.03-.457 2.295L2 2l5.25 1.762-2.295.458 3.03 3.022.015.016.015-.016L8 7.227l3.023-3.022-2.296-.45L14 2.015l-1.762 5.243-.458-2.295L8.742 8l.016.015L8.773 8l3.03 3.03z" class="cls-1"/></svg>`,
};
export const arrowsRepeat16X16: {
  name: 'arrows_repeat_16_x_16';
  data: string;
} = {
  name: 'arrows_repeat_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.75 11.75 10 14l-6-3 6-3-1.25 2.25ZM8 11h1a4 4 0 0 0 4-4M7.25 5.75 6 8l6-3-6-3 1.25 2.25ZM8 5H7a4 4 0 0 0-4 4" class="cls-1"/></svg>`,
};
export const asterisk5X5: {
  name: 'asterisk_5_x_5';
  data: string;
} = {
  name: 'asterisk_5_x_5',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 5"><path d="m.721 4.076.813-1.372-1.429-.63.266-.84 1.527.349L2.05 0h.883l.154 1.583 1.541-.35.266.84-1.442.631.812 1.372-.715.519L2.5 3.376 1.435 4.595z" class="cls-1"/></svg>`,
};
export const at16X16: {
  name: 'at_16_x_16';
  data: string;
} = {
  name: 'at_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 16 16"><path d="M12.139 3.621a5.5 5.5 0 0 1 1.206 1.845q.435 1.074.436 2.407 0 .961-.275 1.954t-.687 1.646H9.343l-.11-.536a4.6 4.6 0 0 1-.756.415q-.364.155-1.051.155-1.12 0-1.813-.924t-.694-2.49q0-.837.234-1.467.234-.628.639-1.095.377-.44.914-.687a2.5 2.5 0 0 1 1.064-.248q.453 0 .804.169.35.168.543.353v-.425h1.594v5.605h1.168q.248-.543.368-1.178.12-.636.12-1.22 0-1.161-.323-2.036-.322-.877-.892-1.453a3.7 3.7 0 0 0-1.366-.879 4.9 4.9 0 0 0-1.697-.289q-.871 0-1.657.343a4.6 4.6 0 0 0-1.383.928q-.61.598-.992 1.497c-.382.899-.381 1.257-.381 1.972q0 1.167.36 2.068.36.9.958 1.497.596.59 1.386.9a4.5 4.5 0 0 0 1.668.309q.583 0 1.328-.106a9 9 0 0 0 1.321-.279v1.333q-.64.144-1.271.22-.633.074-1.381.075a6.1 6.1 0 0 1-2.325-.433 5.4 5.4 0 0 1-1.852-1.23 5.6 5.6 0 0 1-1.212-1.91 6.7 6.7 0 0 1-.436-2.444q0-1.278.453-2.366a5.9 5.9 0 0 1 1.25-1.9A5.7 5.7 0 0 1 5.781 2.46 5.8 5.8 0 0 1 8.079 2q1.209 0 2.257.426a5.3 5.3 0 0 1 1.803 1.195M9.082 9.652V6.19a3 3 0 0 0-.522-.21 2 2 0 0 0-.543-.065q-.66 0-1.017.577c-.357.577-.357.912-.357 1.58q0 1.085.295 1.607.296.522.975.522.357 0 .625-.141.269-.14.544-.408"/></svg>`,
};
export const bars16X16: {
  name: 'bars_16_x_16';
  data: string;
} = {
  name: 'bars_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 13v-2h12v2Zm0-4V7h12v2Zm0-4V3h12v2Z" class="cls-1"/></svg>`,
};
export const bell16X16: {
  name: 'bell_16_x_16';
  data: string;
} = {
  name: 'bell_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 14a2.05 2.05 0 0 1-2-2h4a2.05 2.05 0 0 1-2 2m-5.25-3s0-.746.5-.746h.065c.935 0 1.435-4.918 1.435-4.918 0-.504.25-.504.25-.504h.067c.075-.037.183-.143.183-.463v-.484c.105-.842.953-1.331 2.25-1.43v-.262c0-.081.09-.15.219-.193h.562c.129.043.219.112.219.193v.263c1.297.098 2.145.587 2.25 1.43v.483c0 .32.108.426.183.463H11s.25 0 .25.483v.02s.5 4.92 1.5 4.92c.5 0 .5.745.5.745Z" class="cls-1"/></svg>`,
};
export const bellAndComment16X16: {
  name: 'bell_and_comment_16_x_16';
  data: string;
} = {
  name: 'bell_and_comment_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.836 4.75H9.57a.71.71 0 0 0-.71.71v2.032a.71.71 0 0 0 .71.711h.356L9.57 9.625l2.488-1.422h1.778a.71.71 0 0 0 .71-.71V5.46a.71.71 0 0 0-.71-.711M8.196 11H2.75s0-.746.5-.746h.065c.935 0 1.435-4.918 1.435-4.918 0-.504.25-.504.25-.504h.067c.075-.037.183-.143.183-.463v-.484c.105-.842.953-1.331 2.25-1.43v-.262c0-.081.09-.15.219-.193h.562c.129.043.219.112.219.193v.263c1.224.092 2.04.537 2.217 1.294H9.57a1.713 1.713 0 0 0-1.71 1.71v2.032a1.71 1.71 0 0 0 .844 1.475ZM6 12h4a2.05 2.05 0 0 1-2 2 2.05 2.05 0 0 1-2-2m7.25-1H9.18l2.868-1.64c.198.527.431.894.702.894.5 0 .5.746.5.746" class="cls-1"/></svg>`,
};
export const bellCheck16X16: {
  name: 'bell_check_16_x_16';
  data: string;
} = {
  name: 'bell_check_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.117 11H2.75s0-.746.5-.746h.065c.935 0 1.435-4.918 1.435-4.918 0-.504.25-.504.25-.504h.067c.075-.037.183-.143.183-.463v-.484c.105-.842.953-1.331 2.25-1.43v-.262c0-.081.09-.15.219-.193h.562c.129.043.219.112.219.193v.263c1.297.098 2.145.587 2.25 1.43v.483c0 .32.108.426.183.463H11s.25 0 .25.483v.02s.14 1.37.42 2.664l-1.18 1.164L8.944 7.56l-2.671 2.589zm.99 1H6c.053 1.113.924 2 2 2 .57 0 1.078-.254 1.442-.654zm7.588-4.212-1.162-1.212-4.06 4.01-1.553-1.61-1.225 1.187 2.788 2.813z" class="cls-1"/></svg>`,
};
export const bellCircle16X16: {
  name: 'bell_circle_16_x_16';
  data: string;
} = {
  name: 'bell_circle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.042 11h2a1 1 0 0 1-2 0m4.5-1h-7s0-.497.333-.497h.043c.624 0 .957-3.28.957-3.28 0-.335.167-.335.167-.335h.044c.05-.025.122-.095.122-.309v-.322c.07-.561.636-.888 1.5-.953v-.175c0-.054.06-.1.146-.129h.375c.086.029.146.075.146.129v.175c.865.065 1.43.392 1.5.953v.322c0 .214.072.284.122.309h.045s.166 0 .166.322v.014s.334 3.279 1 3.279c.334 0 .334.497.334.497m-3.5-7.5a5.5 5.5 0 1 1-5.5 5.5 5.506 5.506 0 0 1 5.5-5.5m0-1a6.5 6.5 0 1 0 6.5 6.5 6.5 6.5 0 0 0-6.5-6.5" class="cls-1"/></svg>`,
};
export const bellOn16X16: {
  name: 'bell_on_16_x_16';
  data: string;
} = {
  name: 'bell_on_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9.951 14c-1.075 0-1.946-.887-2-2h4c-.053 1.113-.924 2-2 2m-7.25-3s0-.746.5-.746h.065c.935 0 1.435-4.919 1.435-4.919 0-.503.25-.503.25-.503h.067c.075-.037.184-.143.184-.464v-.483c.105-.842.952-1.331 2.25-1.43v-.262c0-.082.09-.15.218-.193h.563c.128.043.218.111.218.193v.262c1.297.099 2.145.588 2.25 1.43v.483c0 .32.109.427.183.464h.067s.25 0 .25.483v.02s.5 4.92 1.5 4.92c.5 0 .5.745.5.745zM15 8V7h-2v1zM3 8V7H1v1zm10.012-6.29-.707-.708-1.414 1.415.707.707zM3.414 3.124l.707-.707-1.414-1.415L2 1.71z" class="cls-1"/></svg>`,
};
export const bellSolidCircle16X16: {
  name: 'bell_solid_circle_16_x_16';
  data: string;
} = {
  name: 'bell_solid_circle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M1.5 8A6.5 6.5 0 0 0 8 14.5 6.5 6.5 0 0 0 14.5 8 6.5 6.5 0 0 0 8 1.5 6.5 6.5 0 0 0 1.5 8M8 12a1.025 1.025 0 0 1-1-1h2a1.025 1.025 0 0 1-1 1m-3.5-2s0-.497.333-.497h.043c.624 0 .957-3.28.957-3.28 0-.335.167-.335.167-.335h.045c.05-.025.122-.095.122-.309v-.322c.07-.561.635-.888 1.5-.953v-.175c0-.054.06-.1.145-.129h.376c.085.029.145.075.145.129v.175c.865.065 1.43.392 1.5.953v.322c0 .214.073.284.122.309H10s.167 0 .167.322v.014s.333 3.279 1 3.279c.333 0 .333.497.333.497Z" class="cls-1"/></svg>`,
};
export const blockWithRibbon16X16: {
  name: 'block_with_ribbon_16_x_16';
  data: string;
} = {
  name: 'block_with_ribbon_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v10h4.762A4.496 4.496 0 0 1 13 5.762V2Zm12 7.5a3.5 3.5 0 1 0-6 2.442V14l2.5-1.667L13 14v-2.058A3.49 3.49 0 0 0 14 9.5M10.5 8A1.5 1.5 0 1 1 9 9.5 1.5 1.5 0 0 1 10.5 8" class="cls-1"/></svg>`,
};
export const boldB16X16: {
  name: 'bold_b_16_x_16';
  data: string;
} = {
  name: 'bold_b_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 16 16"><path d="M12.981 10.536q0 .843-.34 1.508c-.34.665-.538.81-.934 1.102a4.3 4.3 0 0 1-1.512.734q-.825.219-2.09.219H3.028V2.466h4.516q1.407 0 2.059.094a4.2 4.2 0 0 1 1.293.414q.664.336.988.902t.324 1.293q0 .844-.445 1.488c-.445.644-.716.765-1.258 1.004v.062q1.14.227 1.809.938c.669.711.667 1.099.667 1.875M9.137 5.755q0-.289-.145-.578t-.512-.43a2.5 2.5 0 0 0-.815-.137 68 68 0 0 0-1.372-.011h-.281V7.06h.469q.71 0 1.211-.023.5-.024.789-.157.406-.18.531-.465t.125-.66m.727 4.734q0-.555-.214-.855c-.214-.3-.387-.351-.73-.449q-.35-.102-.966-.11c-.616-.008-.84-.008-1.287-.008h-.655v2.898h.218q1.263 0 1.809-.008a2.7 2.7 0 0 0 1.006-.203q.468-.196.643-.52a1.53 1.53 0 0 0 .176-.745"/></svg>`,
};
export const bookMagnifyingGlass16X16: {
  name: 'book_magnifying_glass_16_x_16';
  data: string;
} = {
  name: 'book_magnifying_glass_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6 10c0-.347.058-.678.142-1H5V8h1.556c.22-.378.498-.714.826-1H5V6h5c.732 0 1.41.212 2 .556V2H3v11h4.382A3.98 3.98 0 0 1 6 10M5 4h5v1H5z" class="cls-1"/><path d="m9.99 7.01-.076.002a3 3 0 1 0 1.799 5.452l1.593 1.53.69-.725-1.58-1.516a2.97 2.97 0 0 0 .57-1.816A3 3 0 0 0 9.99 7.01M10 12c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2" class="cls-1"/></svg>`,
};
export const calendarCheckLines16X16: {
  name: 'calendar_check_lines_16_x_16';
  data: string;
} = {
  name: 'calendar_check_lines_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 3V2h-2v1H6V2H4v1H2v11h12V3zm1 10H3V6h10z" class="cls-2"/><path d="M5.743 11 4 9.242l.766-.742.97 1.007L8.273 7 9 7.758zM10 8h2v1h-2zM8 10h4v1H8z" class="cls-1"/></svg>`,
};
export const calendarClock16X16: {
  name: 'calendar_clock_16_x_16';
  data: string;
} = {
  name: 'calendar_clock_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 8.79V3h-2V2h-2v1H6V2H4v1H2v11h7.47c.545.35 1.19.559 1.885.559a3.5 3.5 0 0 0 3.5-3.5c0-.87-.33-1.657-.855-2.269M3 6h10v1.987a3.46 3.46 0 0 0-1.645-.428A3.5 3.5 0 0 0 8.445 13H3zm9.978 7.041a391 391 0 0 1-1.288-1.304.743.743 0 1 1 0-1.338l.908-.908c.081-.081.356-.149.49-.149 0 .09-.06.358-.134.462-.068.095-.791.822-.917.948a.75.75 0 0 1 0 .633l1.386 1.389s.312.327.268.625c-.208 0-.416-.06-.713-.358" class="cls-1"/></svg>`,
};
export const calendarDay16X16: {
  name: 'calendar_day_16_x_16';
  data: string;
} = {
  name: 'calendar_day_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7 10H4V7h3zm7-7v11H2V3h2V2h2v1h4V2h2v1zm-1 3H3v7h10z" class="cls-1"/></svg>`,
};
export const calendarDayOutline16X16: {
  name: 'calendar_day_outline_16_x_16';
  data: string;
} = {
  name: 'calendar_day_outline_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 3V2h-2v1H6V2H4v1H2v11h12V3zm1 10H3V6h10zM7 7H4v3h3zM6 9H5V8h1z" class="cls-1"/></svg>`,
};
export const calendarDays16X16: {
  name: 'calendar_days_16_x_16';
  data: string;
} = {
  name: 'calendar_days_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 3V2h-2v1H6V2H4v1H2v11h12V3zm1 10H3V6h10zM6 9H4V7h2zm3-2H7v2h2zm3 0h-2v2h2zm-6 3H4v2h2zm3 0H7v2h2z" class="cls-1"/></svg>`,
};
export const calendarLines16X16: {
  name: 'calendar_lines_16_x_16';
  data: string;
} = {
  name: 'calendar_lines_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 3V2h-2v1H6V2H4v1H2v11h12V3zm1 10H3V6h10zm-1-5H4V7h8zm0 2H4V9h8zm0 2H4v-1h8z" class="cls-1"/></svg>`,
};
export const calendarRectangle16X16: {
  name: 'calendar_rectangle_16_x_16';
  data: string;
} = {
  name: 'calendar_rectangle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 3V2h-2v1H6V2H4v1H2v11h12V3zm1 10H3V6h10zm-1-1H4V7h8z" class="cls-1"/></svg>`,
};
export const calendarWeek16X16: {
  name: 'calendar_week_16_x_16';
  data: string;
} = {
  name: 'calendar_week_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g class="cls-3"><path d="M12 3V2h-2v1H6V2H4v1H2v11h12V3zm1 10H3V6h10zm-1-4H4V7h8z" class="cls-1"/></g></svg>`,
};
export const chartDiagram16X16: {
  name: 'chart_diagram_16_x_16';
  data: string;
} = {
  name: 'chart_diagram_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11 10V7H8V5h1V2H6v3h1v2H4v3H3v3h3v-3H5V8h5v2H9v3h3v-3Z" class="cls-1"/></svg>`,
};
export const chartDiagramChildFocus16X16: {
  name: 'chart_diagram_child_focus_16_x_16';
  data: string;
} = {
  name: 'chart_diagram_child_focus_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 10V7H8V5h1V2H6v3h1v2H3v3H2v3h3v-3H4V8h3v2H6v3h3v-3H8V8h3v2h-1v3h3v-3Zm-8 2H3v-1h1Zm4 0H7v-1h1Zm4 0h-1v-1h1Z" class="cls-1"/></svg>`,
};
export const chartDiagramParentFocus16X16: {
  name: 'chart_diagram_parent_focus_16_x_16';
  data: string;
} = {
  name: 'chart_diagram_parent_focus_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 10V7H8V5h1V2H6v3h1v2H3v3H2v3h3v-3H4V8h3v2H6v3h3v-3H8V8h3v2h-1v3h3v-3ZM7 4V3h1v1Z" class="cls-1"/></svg>`,
};
export const chartDiagramParentFocusTwoChild16X16: {
  name: 'chart_diagram_parent_focus_two_child_16_x_16';
  data: string;
} = {
  name: 'chart_diagram_parent_focus_two_child_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11 10V7H8V5h1V2H6v3h1v2H4v3H3v3h3v-3H5V8h5v2H9v3h3v-3Zm-6 2H4v-1h1Zm6 0h-1v-1h1Z" class="cls-1"/></svg>`,
};
export const check16X16: {
  name: 'check_16_x_16';
  data: string;
} = {
  name: 'check_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m14 4.693-8.182 8.182L2 9.057 3.636 7.42l2.25 2.25 6.546-6.545z" class="cls-1"/></svg>`,
};
export const checkDot16X16: {
  name: 'check_dot_16_x_16';
  data: string;
} = {
  name: 'check_dot_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><circle cx="12.5" cy="11.5" r="1.5" class="cls-1"/><path d="m14 4.693-8.182 8.182L2 9.057 3.636 7.42l2.25 2.25 6.546-6.545Z" class="cls-2"/></svg>`,
};
export const circle16X16: {
  name: 'circle_16_x_16';
  data: string;
} = {
  name: 'circle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m0 9.429A3.429 3.429 0 1 1 11.429 8 3.43 3.43 0 0 1 8 11.429" class="cls-1"/></svg>`,
};
export const circleFilled16X16: {
  name: 'circle_filled_16_x_16';
  data: string;
} = {
  name: 'circle_filled_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><circle cx="8" cy="8" r="4" class="cls-1"/></svg>`,
};
export const circleBroken16X16: {
  name: 'circle_broken_16_x_16';
  data: string;
} = {
  name: 'circle_broken_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7 14A6.1 6.1 0 0 1 7 2v2.686a3.475 3.475 0 0 0 0 6.628ZM9 2v2.686a3.475 3.475 0 0 1 0 6.628V14A6.1 6.1 0 0 0 9 2" class="cls-1"/></svg>`,
};
export const circleCheck16X16: {
  name: 'circle_check_16_x_16';
  data: string;
} = {
  name: 'circle_check_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m-1.212 9.2L4 8.388 5.225 7.2l1.553 1.61 4.06-4.01L12 6.013Z" class="cls-1"/></svg>`,
};
export const circleMinus16X16: {
  name: 'circle_minus_16_x_16';
  data: string;
} = {
  name: 'circle_minus_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4m0-2C4.69 2 2 4.69 2 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6m3 7H5V7h6z" class="cls-1"/></svg>`,
};
export const circlePartialBroken16X16: {
  name: 'circle_partial_broken_16_x_16';
  data: string;
} = {
  name: 'circle_partial_broken_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9 2v2.686a3.475 3.475 0 0 1 0 6.628V14A6.1 6.1 0 0 0 9 2" class="cls-1"/><path d="M7 11.314a3.475 3.475 0 0 1 0-6.628V2a6.1 6.1 0 0 0 0 12Z" class="cls-2"/></svg>`,
};
export const circleSlash16X16: {
  name: 'circle_slash_16_x_16';
  data: string;
} = {
  name: 'circle_slash_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m.075 1.714a4.281 4.281 0 0 1 3.573 6.647L5.714 4.427a4.26 4.26 0 0 1 2.36-.713M3.789 8a4.26 4.26 0 0 1 .713-2.36l5.934 5.933A4.281 4.281 0 0 1 3.789 8" class="cls-1"/></svg>`,
};
export const circleX16X16: {
  name: 'circle_x_16_x_16';
  data: string;
} = {
  name: 'circle_x_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m.075 1.714a4.26 4.26 0 0 1 2.409.743l-2.37 2.37-2.4-2.4a4.26 4.26 0 0 1 2.36-.713M4.502 5.64l2.4 2.4-2.37 2.37a4.27 4.27 0 0 1-.03-4.77m3.573 6.647a4.26 4.26 0 0 1-2.31-.685l2.349-2.35 2.322 2.322a4.26 4.26 0 0 1-2.361.713m3.573-1.925L9.326 8.039l2.35-2.349a4.25 4.25 0 0 1-.028 4.67" class="cls-1"/></svg>`,
};
export const clipboard16X16: {
  name: 'clipboard_16_x_16';
  data: string;
} = {
  name: 'clipboard_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11 5H5a2 2 0 0 1 2-2V2a1 1 0 0 1 2 0v1a2 2 0 0 1 2 2m1-2v9H4V3H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-2 4H5v1h5ZM8 9H5v1h3Z" class="cls-1"/></svg>`,
};
export const clock16X16: {
  name: 'clock_16_x_16';
  data: string;
} = {
  name: 'clock_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m.576 4.87 1.555-1.557a1.64 1.64 0 0 1 .84-.256 2 2 0 0 1-.23.791c-.115.163-1.356 1.41-1.571 1.626a1.28 1.28 0 0 1 0 1.085l2.376 2.38a1.6 1.6 0 0 1 .458 1.072 1.62 1.62 0 0 1-1.222-.613c-.456-.456-1.94-1.963-2.207-2.235a1.275 1.275 0 1 1 0-2.293" class="cls-1"/></svg>`,
};
export const clockCog16X16: {
  name: 'clock_cog_16_x_16';
  data: string;
} = {
  name: 'clock_cog_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m8.108 7.392.955-.957a1 1 0 0 1 .516-.157 1.2 1.2 0 0 1-.14.486c-.072.1-.834.866-.966.999a.79.79 0 0 1 0 .666l1.341 1.344a.98.98 0 0 1 .281.658 1 1 0 0 1-.75-.376c-.28-.28-1.073-1.088-1.237-1.255a.783.783 0 1 1 0-1.408m5.69 2.292L14 7.324l-1.327-.113a4.8 4.8 0 0 0-.402-1.26l1.02-.86-1.527-1.811-1.019.86a5 5 0 0 0-.563-.344 5 5 0 0 0-.612-.265l.114-1.329L7.324 2l-.113 1.329a4.8 4.8 0 0 0-1.26.401l-.86-1.02L3.28 4.237l.858 1.02A4.8 4.8 0 0 0 3.53 6.43l-1.329-.114L2 8.676l1.329.114a4.7 4.7 0 0 0 .401 1.26l-1.02.86 1.526 1.811 1.02-.859a4.7 4.7 0 0 0 1.175.608l-.113 1.33 2.358.2.114-1.328a4.7 4.7 0 0 0 1.26-.4l.86 1.02 1.81-1.527-.858-1.02a4.7 4.7 0 0 0 .608-1.175ZM8 11.45A3.45 3.45 0 1 1 11.45 8 3.45 3.45 0 0 1 8 11.45" class="cls-1"/></svg>`,
};
export const clockExclamation16X16: {
  name: 'clock_exclamation_16_x_16';
  data: string;
} = {
  name: 'clock_exclamation_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2.821 5.114h1.357V6H2.82zM2.798 1l.155 3.56h1.094L4.202 1zm7.481 2.575h.001l-.013-.007a5 5 0 0 0-.606-.262 5 5 0 0 0-.523-.163 5 5 0 0 0-.286-.055A4.7 4.7 0 0 0 8 3q-.023.002-.045.005a5 5 0 0 0-.785.079c-.097.016-.194.03-.29.052a5 5 0 0 0-.575.179c-.48.174-.907.438-1.305.74V7H3.109l-.017.092a5 5 0 0 0-.088.87Q3.002 7.98 3 8c0 .293.036.575.088.852q.023.143.055.285.068.273.165.532.11.308.259.595l.007.016h.001c.83 1.608 2.49 2.72 4.426 2.72C10.762 13 13 10.762 13 8c0-1.935-1.112-3.594-2.72-4.425m-.275 7.041c-.38-.38-1.454-1.473-1.675-1.699a1.06 1.06 0 0 1-1.523-.953 1.06 1.06 0 0 1 1.523-.954l1.293-1.296c.117-.117.509-.213.7-.213 0 .128-.085.51-.191.658-.097.136-1.128 1.173-1.308 1.353a1.06 1.06 0 0 1 0 .903l1.816 1.82s.445.466.382.89c-.297 0-.594-.085-1.017-.509" class="cls-1"/></svg>`,
};
export const clockTriangle16X16: {
  name: 'clock_triangle_16_x_16';
  data: string;
} = {
  name: 'clock_triangle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 3a4.95 4.95 0 0 0-2.152.505L7.096 6H3.422A4.997 4.997 0 1 0 8 3m2.003 7.616a454 454 0 0 1-1.675-1.7 1.061 1.061 0 1 1 0-1.907l1.294-1.297a1.36 1.36 0 0 1 .699-.212 1.65 1.65 0 0 1-.19.658c-.097.136-1.13 1.173-1.309 1.353a1.06 1.06 0 0 1 0 .903l1.817 1.82a1.33 1.33 0 0 1 .381.891 1.35 1.35 0 0 1-1.017-.51" class="cls-1"/><path d="M5.477 5H1.522L3.5 1.045z" class="cls-2"/></svg>`,
};
export const clone16X16: {
  name: 'clone_16_x_16';
  data: string;
} = {
  name: 'clone_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5 5h5V2H2v8h3Zm1 1v8h8V6Z" class="cls-1"/></svg>`,
};
export const cloud16X16: {
  name: 'cloud_16_x_16';
  data: string;
} = {
  name: 'cloud_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.08 11.977a5.1 5.1 0 0 1-1.295-.2C2.754 11.46 1.883 10.2 1.883 9.022a2.963 2.963 0 0 1 2.63-2.937A4.2 4.2 0 0 1 8.432 3.48a4.254 4.254 0 0 1 4.249 4.17 2.25 2.25 0 0 1 1.437 2.09 2.24 2.24 0 0 1-2.238 2.237l-4.947.003c-1.01 0-1.79-.001-1.853-.003m-.228-4.573c-.899 0-1.63.725-1.63 1.618 0 .842.702 1.61 1.474 1.61l7.183.007a.9.9 0 0 0 0-1.799.9.9 0 0 0-.337.067l-.493.202.159-.508q.134-.425.134-.872a2.914 2.914 0 0 0-2.91-2.911 2.9 2.9 0 0 0-2.87 2.436l-.043.268-.264-.067a1.6 1.6 0 0 0-.403-.051" class="cls-1"/></svg>`,
};
export const cloudUpload16X16: {
  name: 'cloud_upload_16_x_16';
  data: string;
} = {
  name: 'cloud_upload_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m8.476 7.298-1.927 3.848 1.48-.568v3.407h.948v-3.407l1.42.568ZM15 9.005a2.374 2.374 0 0 1-2.371 2.371h-.998l-.5-1h1.498a1.371 1.371 0 1 0-.516-2.64A3.77 3.77 0 1 0 4.797 5.99 2.238 2.238 0 0 0 2 8.148a2.223 2.223 0 0 0 2.057 2.22l1.758.009-.448.894a10.6 10.6 0 0 1-2.31-.121 3.224 3.224 0 0 1 .993-6.225 4.77 4.77 0 0 1 9.236 1.68q0 .06-.002.121A2.375 2.375 0 0 1 15 9.006" class="cls-1"/></svg>`,
};
export const cloudWithArrow16X16: {
  name: 'cloud_with_arrow_16_x_16';
  data: string;
} = {
  name: 'cloud_with_arrow_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m12.429 10.1.001-.101A3.998 3.998 0 0 0 4.69 8.59a2.715 2.715 0 0 0-2.557 2.7 2.78 2.78 0 0 0 1.725 2.516 4.9 4.9 0 0 0 1.225.19h.004c.19.006 6.792 0 6.792 0a1.987 1.987 0 0 0 .55-3.897m-.55 3.06-7.183-.008a1.867 1.867 0 0 1 .156-3.728 2 2 0 0 1 .464.06 3.16 3.16 0 1 1 6.13 1.462 1.149 1.149 0 1 1 .433 2.213M4.5 4.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1m5.138.681.496-1.241H7v-.828h3.134l-.496-1.293L13 3.502Z" class="cls-1"/></svg>`,
};
export const cog16X16: {
  name: 'cog_16_x_16';
  data: string;
} = {
  name: 'cog_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m6.823 2-2.217.914.516 1.25a4.7 4.7 0 0 0-.95.944L2.925 4.59l-.922 2.212 1.247.52a4.8 4.8 0 0 0-.002 1.34L2 9.176l.914 2.218 1.248-.515a4.8 4.8 0 0 0 .945.949l-.518 1.247 2.214.921.519-1.246a5 5 0 0 0 .674.048 5 5 0 0 0 .666-.047L9.176 14l2.218-.914-.515-1.248a4.8 4.8 0 0 0 .95-.945l1.245.518.922-2.214-1.247-.519a4.7 4.7 0 0 0 .002-1.34L14 6.824l-.914-2.218-1.25.515a4.7 4.7 0 0 0-.944-.949l.518-1.246-2.212-.922-.52 1.247a5 5 0 0 0-.676-.049 5 5 0 0 0-.663.047Zm1.175 9a2.999 2.999 0 1 1 2.77-1.847 2.98 2.98 0 0 1-2.77 1.846M8 6.801a1.2 1.2 0 1 0 .46.093A1.2 1.2 0 0 0 8 6.8" class="cls-1"/></svg>`,
};
export const cogDatabase16X16: {
  name: 'cog_database_16_x_16';
  data: string;
} = {
  name: 'cog_database_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.147 11.648q-.015.01-.032.02a4 4 0 0 1-.46.224l-.012.005q-.05.022-.103.042c-.051.019-.11.036-.162.055-.094.034-.186.068-.285.099-.034.01-.064.024-.1.033q-.03.01-.062.019-.279.078-.58.144l-.133.03q-.324.068-.668.12l-.135.02q-.32.045-.653.079l-.103.012a18 18 0 0 1-.903.06q-.381.016-.759.018a19 19 0 0 1-1.66-.078l-.105-.012a16 16 0 0 1-.65-.08l-.134-.018q-.346-.053-.67-.122l-.132-.029a9 9 0 0 1-.582-.145l-.059-.017q-.052-.016-.1-.034a7 7 0 0 1-.285-.1c-.054-.018-.112-.035-.165-.055l-.101-.041-.01-.005a4 4 0 0 1-.462-.223l-.03-.02a2.3 2.3 0 0 1-.334-.24c-.014-.012-.033-.022-.045-.033v1.013c0 .364.524.749 1.427 1.051q.155.053.326.1.177.051.371.098a14.8 14.8 0 0 0 3.4.362 14.8 14.8 0 0 0 3.403-.362 8 8 0 0 0 .697-.197c.904-.303 1.43-.688 1.43-1.052v-1.013c-.015.012-.034.022-.047.034a2.5 2.5 0 0 1-.333.238m.38-1.883c0-.762-2.27-1.61-5.529-1.61-3.256 0-5.524.848-5.524 1.61 0 .365.525.75 1.427 1.052q.155.052.328.1.175.05.37.097a14.8 14.8 0 0 0 3.399.362 14.8 14.8 0 0 0 3.401-.362 8 8 0 0 0 .7-.197c.902-.302 1.428-.687 1.428-1.052M3.931 7.697 2.802 7.6l.171-1.979 1.129.095a4 4 0 0 1 .516-.985l-.729-.856 1.537-1.28.73.855a4 4 0 0 1 1.071-.336L7.323 2l2.004.17-.097 1.114a4 4 0 0 1 .52.223 4 4 0 0 1 .478.288l.866-.721 1.296 1.52-.866.72a4 4 0 0 1 .341 1.058l1.127.095-.133 1.539a10.2 10.2 0 0 0-2.482-.618c.007-.048.021-.094.026-.143a2.48 2.48 0 0 0-1.346-2.416 2.54 2.54 0 0 0-2.938.45 2.41 2.41 0 0 0-.698 2.14 12 12 0 0 0-1.482.311zm4.067-.468c-.331 0-.697.012-1.077.035a1 1 0 0 1-.026-.314 1 1 0 0 1 .292-.618 1.01 1.01 0 0 1 1.174-.18.99.99 0 0 1 .539.967 1 1 0 0 1-.036.132 18 18 0 0 0-.866-.022" class="cls-1"/></svg>`,
};
export const cogDatabaseInset16X16: {
  name: 'cog_database_inset_16_x_16';
  data: string;
} = {
  name: 'cog_database_inset_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12.751 7.338 14 6.824l-.914-2.218-1.25.515a4.7 4.7 0 0 0-.944-.949l.518-1.246-2.212-.922-.52 1.247a5 5 0 0 0-.676-.049 5 5 0 0 0-.663.047L6.823 2l-2.217.914.516 1.25a4.7 4.7 0 0 0-.95.944L2.925 4.59l-.922 2.212 1.247.52a4.8 4.8 0 0 0-.002 1.34L2 9.176l.914 2.218 1.248-.515a4.8 4.8 0 0 0 .945.949l-.518 1.247 2.214.921.519-1.246a5 5 0 0 0 .674.048 5 5 0 0 0 .666-.047L9.176 14l2.218-.914-.515-1.248a4.8 4.8 0 0 0 .95-.945l1.245.518.922-2.214-1.247-.519a4.7 4.7 0 0 0 .002-1.34m-1.06 2.418c0 .244-.35.5-.954.703a5 5 0 0 1-.466.131 10 10 0 0 1-2.273.243 10 10 0 0 1-2.271-.243 6 6 0 0 1-.466-.131c-.603-.202-.953-.46-.953-.703V9.08q.013.011.03.023a1.6 1.6 0 0 0 .223.16l.02.013a3 3 0 0 0 .309.15l.006.002.068.028q.054.02.11.037.093.035.19.066.033.012.067.023l.04.011q.185.054.389.098l.087.02q.217.045.448.08l.09.012q.212.03.434.054l.07.008q.244.022.491.035l.112.005a12 12 0 0 0 1.013 0l.11-.005q.248-.012.493-.035l.069-.008q.222-.022.436-.054l.09-.012q.23-.035.447-.08l.088-.02q.202-.045.388-.097l.042-.012.066-.023q.098-.03.19-.066.056-.018.109-.037l.069-.028.007-.003a3 3 0 0 0 .308-.149l.022-.014a2 2 0 0 0 .222-.159l.03-.023Zm0-1.76c0 .243-.35.5-.954.703a5 5 0 0 1-.466.13 10 10 0 0 1-2.273.243 10 10 0 0 1-2.271-.242 5 5 0 0 1-.466-.132c-.603-.202-.953-.459-.953-.703V7.32q.013.011.03.022a1.6 1.6 0 0 0 .223.16l.02.013a3 3 0 0 0 .309.15l.006.003q.034.014.068.027l.11.038q.093.034.19.066.033.011.067.023l.04.011q.185.052.389.097l.087.02q.217.045.448.08l.09.013q.212.03.434.053l.07.008a12 12 0 0 0 1.726.035q.248-.012.493-.035l.069-.008q.222-.023.436-.053l.09-.012q.23-.036.447-.081l.088-.02q.202-.044.388-.097.022-.005.042-.012.033-.01.067-.022.096-.031.19-.066l.108-.037.069-.028.008-.003a3 3 0 0 0 .307-.15l.022-.013a2 2 0 0 0 .222-.16q.015-.01.03-.022Zm-.953-1.05q-.105.034-.22.066-.117.035-.247.065a10 10 0 0 1-2.272.242 10 10 0 0 1-2.271-.242 6 6 0 0 1-.466-.132c-.603-.201-.954-.459-.954-.702 0-.51 1.515-1.076 3.69-1.076 2.177 0 3.694.567 3.694 1.076 0 .243-.351.5-.954.702" class="cls-1"/></svg>`,
};
export const cogSmallCog16X16: {
  name: 'cog_small_cog_16_x_16';
  data: string;
} = {
  name: 'cog_small_cog_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6.712 5.956a.76.76 0 0 1-.224.477.79.79 0 0 1-.909.139.762.762 0 0 1-.19-1.224.78.78 0 0 1 .907-.14.77.77 0 0 1 .416.748M14 11.61l-.441 1.088-.62-.246a2 2 0 0 1-.232.268 2 2 0 0 1-.23.2l.263.606-1.09.46-.263-.606a2.4 2.4 0 0 1-.662.008l-.248.612-1.1-.435.249-.612a2 2 0 0 1-.256-.215 2.4 2.4 0 0 1-.218-.243l-.614.26-.466-1.077.614-.259a2.3 2.3 0 0 1-.008-.654l-.62-.246.44-1.087.62.246a2.4 2.4 0 0 1 .234-.27 3 3 0 0 1 .229-.198l-.263-.606 1.09-.46.263.605a2.4 2.4 0 0 1 .662-.008l.248-.612 1.1.436-.248.612a2.4 2.4 0 0 1 .473.458l.614-.26.466 1.076-.613.26a2.3 2.3 0 0 1 .008.654Zm-1.934-1.591a1.495 1.495 0 0 0-2.085.011 1.454 1.454 0 0 0 .01 2.081 1.5 1.5 0 0 0 .486.313 1.5 1.5 0 0 0 1.6-.324 1.454 1.454 0 0 0-.01-2.081M9.036 8.33l-1.189.99-.564-.661a3.1 3.1 0 0 1-.827.26l-.075.86-1.547-.13.074-.862a3 3 0 0 1-.77-.394l-.671.557-1.001-1.174.67-.557a3 3 0 0 1-.264-.817L2 6.328 2.132 4.8l.872.074a3 3 0 0 1 .4-.762l-.564-.66 1.188-.99.565.66a3.2 3.2 0 0 1 .827-.26L5.494 2l1.548.131-.074.861a3 3 0 0 1 .402.172 3 3 0 0 1 .369.223l.669-.557L9.41 4.004l-.67.557a3 3 0 0 1 .264.818l.871.073-.132 1.53-.872-.074a3 3 0 0 1-.4.762ZM7.874 6.054a1.92 1.92 0 0 0-1.04-1.868 1.965 1.965 0 0 0-2.27.348 1.907 1.907 0 0 0 .478 3.06 1.965 1.965 0 0 0 2.27-.347 1.9 1.9 0 0 0 .562-1.193m3.376 4.467a.6.6 0 0 0-.64.13.6.6 0 0 0-.131.196.584.584 0 0 0 .33.761.6.6 0 0 0 .64-.13.6.6 0 0 0 .13-.195.58.58 0 0 0-.135-.637.6.6 0 0 0-.194-.125" class="cls-1"/></svg>`,
};
export const cogZoomed16X16: {
  name: 'cog_zoomed_16_x_16';
  data: string;
} = {
  name: 'cog_zoomed_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m14 3.11-1.178-.632-1.875 2.133a5.4 5.4 0 0 0-.716-.094L8.766 2l-2.138.627.2 2.863a5 5 0 0 0-.527.47l-2.77-.738-1.056 1.95L4.656 9.04a5 5 0 0 0-.087.704L2 11.144l.659 2.1 2.914-.197a5 5 0 0 0 .453.525l-.13.427h7.232a.82.82 0 0 0 .87-.759L14 13.2Zm-1.335 7.876a2.877 2.877 0 0 1-3.741 1.477 2.77 2.77 0 0 1-1.51-3.66 2.876 2.876 0 0 1 3.729-1.482 2.76 2.76 0 0 1 1.535 3.637Z" class="cls-1"/></svg>`,
};
export const comment16X16: {
  name: 'comment_16_x_16';
  data: string;
} = {
  name: 'comment_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 3.5v6a1.5 1.5 0 0 1-1.5 1.5H8.75L3.5 14l.75-3H3.5A1.5 1.5 0 0 1 2 9.5v-6A1.5 1.5 0 0 1 3.5 2h9A1.5 1.5 0 0 1 14 3.5" class="cls-1"/></svg>`,
};
export const computerAndMonitor16X16: {
  name: 'computer_and_monitor_16_x_16';
  data: string;
} = {
  name: 'computer_and_monitor_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 12V6H5v6h4v1H7v1h5v-1h-2v-1Zm-8-1V7h7v4Zm1-6H4V4h3Zm1 0V3H3v7h1v3h2v1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2Z" class="cls-1"/></svg>`,
};
export const copy16X16: {
  name: 'copy_16_x_16';
  data: string;
} = {
  name: 'copy_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5 5h5V2H2v8h3Zm1 1v8h8V6Zm7 7H7V7h6Z" class="cls-1"/></svg>`,
};
export const copyText16X16: {
  name: 'copy_text_16_x_16';
  data: string;
} = {
  name: 'copy_text_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5 5h5V2H2v8h3Zm1 1v8h8V6Zm7 7H7V7h6Zm-1-4H8V8h4Zm-1 2H8v-1h3Z" class="cls-1"/></svg>`,
};
export const dashboardBuilder16X16: {
  name: 'dashboard_builder_16_x_16';
  data: string;
} = {
  name: 'dashboard_builder_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4.646 6.646 7 4.293l2 2 1.646-1.646.707.707L9 7.707l-2-2-1.646 1.647ZM14 2v12H2V2ZM8 9H4v3h4Zm4 2H9v1h3Zm0-2H9v1h3Zm0-5H4v4h8zm-5 6H5v1h2Z" class="cls-1"/></svg>`,
};
export const dashboardBuilderLegend16X16: {
  name: 'dashboard_builder_legend_16_x_16';
  data: string;
} = {
  name: 'dashboard_builder_legend_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v12h12V2Zm10 10H4v-1.293l2.04-2.04 3.804 2.983L12 9.74Zm0-7h-2v1h2v2.405L9.805 10.35 5.96 7.333 4 9.293V6h2V5H4V4h8ZM9 6H7V5h2Z" class="cls-1"/></svg>`,
};
export const dashboardBuilderTemplates16X16: {
  name: 'dashboard_builder_templates_16_x_16';
  data: string;
} = {
  name: 'dashboard_builder_templates_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v12h12V2Zm11 11H3V3h10Z" class="cls-1"/><path d="M9 9h3v1H9zM12 4H4v4h8Zm-1 3H5V5h6ZM8 9H4v3h4Zm-1 2H5v-1h2ZM9 11h3v1H9z" class="cls-1"/></svg>`,
};
export const dashboardBuilderTile16X16: {
  name: 'dashboard_builder_tile_16_x_16';
  data: string;
} = {
  name: 'dashboard_builder_tile_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4.646 10.646 7 8.293l2 2 1.646-1.646.707.707L9 11.707l-2-2-1.646 1.647ZM14 2v12H2V2ZM4 7h3V4H4Zm8 1H4v4h8zm0-4H8v3h4Z" class="cls-1"/></svg>`,
};
export const database16X16: {
  name: 'database_16_x_16';
  data: string;
} = {
  name: 'database_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.588 11.46a3 3 0 0 0 .36-.257c.015-.012.036-.023.051-.036v1.093c0 .395-.57.81-1.551 1.137a9.133 9.133 0 0 1-.757.212A16.2 16.2 0 0 1 7.997 14a16 16 0 0 1-3.69-.391 9 9 0 0 1-.757-.213C2.57 13.069 2 12.655 2 12.26v-1.093c.013.013.033.023.049.036a2.6 2.6 0 0 0 .362.26q.017.01.033.02a4 4 0 0 0 .502.241l.01.005.11.046c.058.02.121.039.18.06q.15.055.308.106c.037.012.07.026.11.037.018.006.042.011.063.017.2.06.412.11.633.159l.142.031q.352.073.727.13.073.011.146.02a17 17 0 0 0 .82.1 25 25 0 0 0 .98.065c.273.01.55.019.822.019q.41-.001.824-.02.09-.005.179-.007.403-.022.801-.057l.112-.014q.36-.035.708-.086.073-.009.147-.02.374-.057.725-.13.074-.017.144-.031.328-.072.63-.157.034-.01.069-.02c.037-.01.07-.024.108-.036.107-.034.206-.07.309-.107.057-.02.12-.038.176-.06q.056-.02.111-.045l.013-.005a4 4 0 0 0 .5-.241zm0-2.845-.035.022a5 5 0 0 1-.5.241l-.013.005q-.055.023-.111.045l-.176.06c-.103.037-.202.073-.31.107-.037.012-.07.025-.107.036q-.035.01-.069.02a11 11 0 0 1-.774.187q-.35.075-.725.13-.074.012-.147.021-.348.051-.708.086L9.8 9.59q-.398.037-.801.057l-.18.008q-.413.019-.823.02a19 19 0 0 1-.823-.02l-.18-.008a21 21 0 0 1-.8-.057l-.113-.013q-.36-.035-.706-.086-.073-.008-.146-.02a13 13 0 0 1-1.502-.32c-.021-.006-.045-.01-.063-.017-.04-.012-.073-.025-.11-.037a8 8 0 0 1-.309-.107c-.058-.02-.121-.039-.179-.06l-.11-.045-.01-.005a4 4 0 0 1-.502-.241c-.012-.007-.02-.014-.033-.02a2.5 2.5 0 0 1-.362-.26c-.016-.013-.036-.023-.049-.036v1.093c0 .394.57.81 1.55 1.136q.167.056.354.108.191.054.402.105a16 16 0 0 0 3.691.39 16.2 16.2 0 0 0 3.694-.39 9 9 0 0 0 .757-.213c.98-.327 1.551-.742 1.551-1.136V8.322c-.015.013-.036.024-.05.036a3 3 0 0 1-.361.258m0-2.845-.035.022a5 5 0 0 1-.5.241l-.013.005q-.055.023-.111.045l-.176.06c-.103.037-.202.073-.31.107-.037.012-.07.026-.107.036q-.034.01-.069.02-.302.084-.63.156l-.144.031q-.351.075-.725.132-.074.009-.147.02-.348.049-.708.085l-.112.013a19 19 0 0 1-.98.066q-.414.016-.824.018a21 21 0 0 1-1.802-.084l-.114-.013q-.36-.036-.706-.086l-.146-.02q-.375-.057-.727-.13c-.05-.01-.094-.022-.142-.032q-.33-.072-.633-.157l-.063-.018c-.04-.011-.073-.025-.11-.037a8 8 0 0 1-.309-.107l-.179-.06-.11-.045-.01-.005a4 4 0 0 1-.502-.241c-.012-.007-.02-.014-.033-.02a2.5 2.5 0 0 1-.362-.26C2.033 5.5 2.013 5.488 2 5.476V6.57c0 .394.57.81 1.55 1.136q.167.056.354.108.191.054.402.105a16 16 0 0 0 3.691.39 16.2 16.2 0 0 0 3.694-.39 9 9 0 0 0 .757-.213c.98-.327 1.551-.742 1.551-1.136V5.477c-.015.013-.036.024-.05.036a3 3 0 0 1-.361.258M14 3.738C14 2.915 11.535 2 7.998 2 4.463 2 2 2.915 2 3.738c0 .394.57.81 1.55 1.135q.168.057.355.11.192.053.402.103a16.2 16.2 0 0 0 3.69.39 16.2 16.2 0 0 0 3.692-.39 9 9 0 0 0 .759-.213C13.429 4.548 14 4.132 14 3.738" class="cls-1"/></svg>`,
};
export const databaseCheck16X16: {
  name: 'database_check_16_x_16';
  data: string;
} = {
  name: 'database_check_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.919 12.103a12 12 0 0 1-1.594-.26 8 8 0 0 1-.644-.182c-.835-.28-1.32-.635-1.32-.973v-.936c.011.01.029.02.042.031a2 2 0 0 0 .308.222l.028.018a4 4 0 0 0 .428.206l.009.005.093.038c.049.019.103.034.153.051q.129.048.262.092c.032.01.06.022.094.032l.054.014q.256.075.538.136l.121.027q.301.062.62.111.062.01.124.018.295.042.6.073l.038.005-.613.613Zm-2.238-7.74q.145.049.303.093.163.045.343.09a13.7 13.7 0 0 0 3.142.333 13.7 13.7 0 0 0 3.144-.334 8 8 0 0 0 .646-.182c.835-.28 1.32-.635 1.32-.973 0-.704-2.098-1.488-5.11-1.488-3.01 0-5.107.784-5.107 1.488 0 .338.486.694 1.32.973m5.047 6.495.008.007.008-.008Zm-5.047-4.07q.142.049.301.093.164.046.343.09a13.7 13.7 0 0 0 3.143.334 13.7 13.7 0 0 0 3.146-.335 8 8 0 0 0 .644-.181c.835-.28 1.321-.636 1.321-.973v-.937c-.013.012-.03.02-.043.032a2.3 2.3 0 0 1-.307.22l-.03.02a4 4 0 0 1-.426.206l-.01.004q-.047.02-.096.039c-.047.017-.101.033-.15.05q-.128.049-.263.092-.046.017-.092.032l-.058.016q-.257.073-.537.134l-.122.027q-.3.063-.618.112l-.124.017q-.297.043-.604.074l-.095.01a16 16 0 0 1-.835.057q-.352.015-.701.016a17 17 0 0 1-1.535-.072l-.097-.011a15 15 0 0 1-.6-.074l-.125-.017q-.319-.05-.62-.112l-.12-.027a9 9 0 0 1-.54-.134q-.028-.008-.053-.016c-.034-.01-.062-.022-.094-.032a7 7 0 0 1-.262-.091c-.05-.018-.104-.034-.153-.052l-.093-.038-.01-.004a4 4 0 0 1-.427-.207l-.028-.017a2 2 0 0 1-.308-.223c-.013-.011-.031-.02-.042-.03v.936c0 .337.485.692 1.32.972m0 2.436q.142.049.301.093.164.046.343.09a13 13 0 0 0 2.644.327l.318-.318.323.324a14.4 14.4 0 0 0 2.473-.222l1.753-1.753-.063.028-.01.004q-.047.02-.096.04c-.047.017-.101.033-.15.05-.087.032-.171.063-.263.091-.032.01-.06.022-.092.032q-.029.008-.058.017a9 9 0 0 1-.66.16q-.298.064-.617.112l-.124.017q-.297.044-.604.074l-.095.011q-.339.03-.682.049l-.153.007q-.352.016-.701.016-.35 0-.7-.016l-.155-.007a17 17 0 0 1-.68-.049l-.097-.011a15 15 0 0 1-.6-.074q-.063-.008-.125-.017a11 11 0 0 1-1.28-.274l-.053-.015c-.034-.01-.062-.021-.094-.032a7 7 0 0 1-.262-.09c-.05-.018-.104-.034-.153-.053q-.046-.017-.093-.038l-.01-.004a4 4 0 0 1-.427-.207l-.028-.017a2 2 0 0 1-.308-.223c-.014-.01-.031-.02-.042-.03v.936c0 .337.485.693 1.32.972m9.269-1.6L8.736 11.84l-1.449-1.45-1.053 1.055 2.458 2.458 5.268-5.268Z" class="cls-1"/></svg>`,
};
export const debug16X16: {
  name: 'debug_16_x_16';
  data: string;
} = {
  name: 'debug_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.875 11.673a1 1 0 0 1-2 0c0-.02.01-.038.012-.058l-.741-.494C9.97 12.783 8 14 8 14s-2.003-1.36-3.174-3.027l-.963.642c.002.02.012.037.012.058a1 1 0 1 1-1-1 1 1 0 0 1 .435.109l1.01-.674C4.124 9.685 4 9.255 4 8.832v-.16h-.528a.99.99 0 0 1-.847.5 1 1 0 0 1 0-2c.366 0 .673.207.847.5H4V5h1.375v-.903a.99.99 0 0 1-.5-.847 1 1 0 0 1 2 0 .99.99 0 0 1-.5.847V5h3.25v-.903a.99.99 0 0 1-.5-.847 1 1 0 0 1 2 0 .99.99 0 0 1-.5.847V5H12v2.673h.278c.174-.294.48-.5.847-.5a1 1 0 1 1 0 2 .99.99 0 0 1-.847-.5H12v.159c0 .488-.133.967-.346 1.426l.786.524a1 1 0 0 1 .435-.11 1 1 0 0 1 1 1" class="cls-1"/></svg>`,
};
export const desktop16X16: {
  name: 'desktop_16_x_16';
  data: string;
} = {
  name: 'desktop_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 3H2v8h5v1H5v1h6v-1H9v-1h5V3Zm0 7H3V4h10Z" class="cls-1"/></svg>`,
};
export const donutChart16X16: {
  name: 'donut_chart_16_x_16';
  data: string;
} = {
  name: 'donut_chart_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.872 10.956a4.123 4.123 0 0 1-6.997-2.962v-.007H2v.007a5.995 5.995 0 0 0 10.301 4.182ZM8.372 2v1.884a4.13 4.13 0 0 1 2.992 6.501l1.429 1.224A6.008 6.008 0 0 0 8.37 2M2.048 7.236h1.897a4.12 4.12 0 0 1 3.675-3.352V2A6.01 6.01 0 0 0 2.05 7.236" class="cls-1"/></svg>`,
};
export const dotSolidDotStroke16X16: {
  name: 'dot_solid_dot_stroke_16_x_16';
  data: string;
} = {
  name: 'dot_solid_dot_stroke_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7 8a3 3 0 1 1-3-3 3 3 0 0 1 3 3m5-2a2 2 0 1 0 2 2 2 2 0 0 0-2-2m0-1a3 3 0 1 1-3 3 3 3 0 0 1 3-3" class="cls-1"/></svg>`,
};
export const dotSolidDotStrokeMeasurement16X16: {
  name: 'dot_solid_dot_stroke_measurement_16_x_16';
  data: string;
} = {
  name: 'dot_solid_dot_stroke_measurement_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5 3h1v3H5zM6 4h4v1H6zM10 3h1v3h-1zM7 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0m5-2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6" class="cls-1"/></svg>`,
};
export const downRightFromSquare16X16: {
  name: 'down_right_from_square_16_x_16';
  data: string;
} = {
  name: 'down_right_from_square_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m5.958 10.03 2.063-6.281.49 2.344 4.117-4.122 1.414 1.414L9.94 7.487l2.324.504z" class="cls-1"/><path d="M8 10.42V12H4V8h1.572l.657-2H2v8h8V9.774z" class="cls-1"/></svg>`,
};
export const download16X16: {
  name: 'download_16_x_16';
  data: string;
} = {
  name: 'download_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 9v5H2V9h1v4h10V9Zm-5.982 2L11 5.1 8.996 6.412 9 2H7v4.387L5 5.1Z" class="cls-1"/></svg>`,
};
export const electronicChipZoomed16X16: {
  name: 'electronic_chip_zoomed_16_x_16';
  data: string;
} = {
  name: 'electronic_chip_zoomed_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 14H7.333V9.333a2 2 0 0 1 2-2H14V13a1 1 0 0 1-1 1M12 2a.667.667 0 0 0-.667.667v2h1.334v-2A.667.667 0 0 0 12 2M8.444 2a.667.667 0 0 0-.666.667v2H9.11v-2A.667.667 0 0 0 8.444 2M2 8.444a.667.667 0 0 0 .667.667h2V7.778h-2A.667.667 0 0 0 2 8.444M2 12a.667.667 0 0 0 .667.667h2v-1.334h-2A.667.667 0 0 0 2 12m11.556-8.222v.889a.444.444 0 0 1-.445.444H10.89a.444.444 0 0 1-.445-.444v-.89H10v.89a.444.444 0 0 1-.444.444H7.333a.444.444 0 0 1-.444-.444v-.89H4.667a.89.89 0 0 0-.89.89v2.222h.89a.444.444 0 0 1 .444.444v2.223a.444.444 0 0 1-.444.444h-.89v.444h.89a.444.444 0 0 1 .444.445v2.222a.444.444 0 0 1-.444.445h-.89V14H6.89V8.222A1.333 1.333 0 0 1 8.222 6.89H14V3.778Z" class="cls-1"/></svg>`,
};
export const exclamationMark16X16: {
  name: 'exclamation_mark_16_x_16';
  data: string;
} = {
  name: 'exclamation_mark_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6.371 11.873h3.256V14H6.37ZM6.316 2l.37 8.542h2.628L9.684 2Z" class="cls-1"/></svg>`,
};
export const eye16X16: {
  name: 'eye_16_x_16';
  data: string;
} = {
  name: 'eye_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.856 3.657A7 7 0 0 0 1 8.001a7.59 7.59 0 0 0 7.146 4.342A7 7 0 0 0 15 8a7.59 7.59 0 0 0-7.144-4.344m-1.199 7.289A5.11 5.11 0 0 1 2.443 8s.665-2.585 4.33-3.037a2.8 2.8 0 0 0-1.414 1.223l2.787 1.22H4.977a3.5 3.5 0 0 0-.053.576 3.35 3.35 0 0 0 1.734 2.962m2.85.02a3.4 3.4 0 0 0 .107-5.908 5 5 0 0 1 3.942 2.944s-.603 2.44-4.05 2.963" class="cls-1"/></svg>`,
};
export const eyeDash16X16: {
  name: 'eye_dash_16_x_16';
  data: string;
} = {
  name: 'eye_dash_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.832 3.902a9.5 9.5 0 0 1 2.024-.245c3.264.09 5.676 1.427 7.144 4.344-.543 1.222-1.279 2.157-2.173 2.852l-.83-.825c1.277-.888 1.56-2.027 1.56-2.027a5 5 0 0 0-3.942-2.944 3.36 3.36 0 0 1 1.664 2.926 3.3 3.3 0 0 1-.196 1.137zm-.674 3.505h-.18q-.052.286-.054.576a3.35 3.35 0 0 0 1.734 2.962 5.11 5.11 0 0 1-4.215-2.944s.252-.981 1.303-1.84c.029-.024.067-.046.097-.069l-.828-.828C2.19 5.947 1.512 6.849 1 8c1.469 2.916 3.882 4.252 7.146 4.342a9.7 9.7 0 0 0 1.754-.194zm-1.77-4.733-.708.708 9.9 9.9.707-.708z" class="cls-1"/></svg>`,
};
export const fancyA16X16: {
  name: 'fancy_a_16_x_16';
  data: string;
} = {
  name: 'fancy_a_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.597 9.844H7.865A7.5 7.5 0 0 1 6.19 11.96a3.32 3.32 0 0 1-2.042.667 2.84 2.84 0 0 1-1.964-.753L2 11.706l1.153-1.152.157.251a1.35 1.35 0 0 0 1.2.716 1.98 1.98 0 0 0 1.385-.625 11.6 11.6 0 0 0 1.722-2.403l2.252-3.88a8 8 0 0 0-.679-.037 2.37 2.37 0 0 0-1.66.54 1.97 1.97 0 0 0-.556 1.51V6.7l-.067.106-1.564.762.045-.423a3.85 3.85 0 0 1 .645-1.874 3.3 3.3 0 0 1 1.34-1.177 6.7 6.7 0 0 1 2.208-.443c.127 0 .277-.013.471-.029l.369-.03 1.387-.257.087 2.154.33 3.886a4.9 4.9 0 0 0 .29 1.701.5.5 0 0 0 .528.31c.057 0 .277 0 .641-.03L14 11.33l-.172.83-3.003.506Zm-.086-.896-.275-3.22-1.855 3.22Z" class="cls-1"/></svg>`,
};
export const file16X16: {
  name: 'file_16_x_16';
  data: string;
} = {
  name: 'file_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 3v10h8V7H8V3Zm5 0v3h3Z" class="cls-1"/></svg>`,
};
export const fileArrowCurvedRight16X16: {
  name: 'file_arrow_curved_right_16_x_16';
  data: string;
} = {
  name: 'file_arrow_curved_right_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m7 2 3 3H7zM6 6V2H2v12h4.282l.03-.187A4.51 4.51 0 0 1 10 10.065V6zm8 5.5L11 9v2c-1.817-.091-3.412 1.137-3.701 2.97.576-.672 2.077-2.065 3.701-1.82V14z" class="cls-1"/></svg>`,
};
export const fileDrawer16X16: {
  name: 'file_drawer_16_x_16';
  data: string;
} = {
  name: 'file_drawer_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 4v10h12V4Zm8 4H6V6h4Zm4-5H2V2h12Z" class="cls-1"/></svg>`,
};
export const fileSearch16X16: {
  name: 'file_search_16_x_16';
  data: string;
} = {
  name: 'file_search_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 6v6h-3.333a3.7 3.7 0 0 0 .249-1.302A3.7 3.7 0 0 0 7.22 7 3.7 3.7 0 0 0 6 7.223V2h4v4Zm-3-4v3h3Zm-1.126 8.698a2.697 2.697 0 0 1-4.73 1.772L2.521 14l-.48-.823 2.613-1.523a2.698 2.698 0 1 1 5.22-.956m-.952 0a1.745 1.745 0 1 0-1.745 1.745 1.747 1.747 0 0 0 1.745-1.745" class="cls-1"/></svg>`,
};
export const filter16X16: {
  name: 'filter_16_x_16';
  data: string;
} = {
  name: 'filter_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 3.045v1.29h.787a2.069 2.069 0 1 0 2.907 2.903l1.32 2.173v4.522l1.973-1.846V9.411l3.878-5.076h1.134v-1.29Zm2.033 4.059a1.154 1.154 0 0 1 0-2.308c.023 0 .045.006.068.007l1.002 1.575a1.15 1.15 0 0 1-1.07.726" class="cls-1"/></svg>`,
};
export const floppyDisk16X16: {
  name: 'floppy_disk_16_x_16';
  data: string;
} = {
  name: 'floppy_disk_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12.455 4H3.583A.585.585 0 0 0 3 4.598V11.5l1.5 1.497 7.858.003c.33 0 .6-.27.6-.6L13 4.545c0-.33-.215-.546-.545-.546M11 12H8v-2H6v2H5V9h6zm1-4H4V5h8z" class="cls-1"/></svg>`,
};
export const floppyDiskCheckmark16X16: {
  name: 'floppy_disk_checkmark_16_x_16';
  data: string;
} = {
  name: 'floppy_disk_checkmark_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12.455 5h-1.041l-1.005 1H12v3H4V6h3.782L6.79 5H3.583A.585.585 0 0 0 3 5.598V12.5l1.5 1.497 7.858.003a.6.6 0 0 0 .6-.6L13 5.545A.513.513 0 0 0 12.455 5M11 13H8v-2H6v2H5v-3h6Zm2-10.99L9.091 5.9 7 3.79l.919-.89 1.164 1.208L12.128 1.1z" class="cls-1"/></svg>`,
};
export const floppyDiskPen16X16: {
  name: 'floppy_disk_pen_16_x_16';
  data: string;
} = {
  name: 'floppy_disk_pen_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.803 11H7V9H5v2H4V8h6v.617l1.469-1.471q.227-.224.514-.347L12 3.546c0-.33-.215-.546-.545-.546H2.583A.585.585 0 0 0 2 3.598V10.5l1.5 1.497L7.372 12zM3 7V4h8v3zm11.166 1.935L13.09 7.859a.64.64 0 0 0-.908 0l-3.388 3.393-1.503 3.483 3.487-1.5 3.388-3.392a.64.64 0 0 0 0-.908m-5.683 4.803-.198-.199.916-2.116.34 1.06 1.058.35z" class="cls-1"/></svg>`,
};
export const floppyDiskStarArrowRight16X16: {
  name: 'floppy_disk_star_arrow_right_16_x_16';
  data: string;
} = {
  name: 'floppy_disk_star_arrow_right_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.5 2.5a1 1 0 1 0-1 1 1 1 0 0 0 1-1m7.5.002L9.638.819l.496 1.293H7v.828h3.134L9.638 4.18ZM12.455 5H3.583A.585.585 0 0 0 3 5.598V12.5l1.5 1.497 7.858.003a.6.6 0 0 0 .6-.6L13 5.545A.513.513 0 0 0 12.455 5M11 13H8v-2H6v2H5v-3h6Zm1-4H4V6h8Z" class="cls-1"/></svg>`,
};
export const floppyDiskThreeDots16X16: {
  name: 'floppy_disk_three_dots_16_x_16';
  data: string;
} = {
  name: 'floppy_disk_three_dots_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6 3a1 1 0 1 0-1 1 1 1 0 0 0 1-1m3 0a1 1 0 1 0-1 1 1 1 0 0 0 1-1m3 0a1 1 0 1 0-1 1 1 1 0 0 0 1-1m.455 2H3.583A.585.585 0 0 0 3 5.598V12.5l1.5 1.497 7.858.003a.6.6 0 0 0 .6-.6L13 5.545A.513.513 0 0 0 12.455 5M11 13H8v-2H6v2H5v-3h6Zm1-4H4V6h8Z" class="cls-1"/></svg>`,
};
export const folder16X16: {
  name: 'folder_16_x_16';
  data: string;
} = {
  name: 'folder_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7 4V3H2v10h12V4Zm6 2H3V5h10Z" class="cls-1"/></svg>`,
};
export const folderOpen16X16: {
  name: 'folder_open_16_x_16';
  data: string;
} = {
  name: 'folder_open_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7 3v1.002h6V6h-1V5H3v1H2V3ZM2 13h11l1-6H2Z" class="cls-1"/></svg>`,
};
export const forwardSlash16X16: {
  name: 'forward_slash_16_x_16';
  data: string;
} = {
  name: 'forward_slash_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m6.027 14 2.5-12h1.5l-2.5 12z" class="cls-1"/></svg>`,
};
export const fourDotsSquare16X16: {
  name: 'four_dots_square_16_x_16';
  data: string;
} = {
  name: 'four_dots_square_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6.5 11A1.5 1.5 0 1 1 5 9.5 1.5 1.5 0 0 1 6.5 11M5 3.5A1.5 1.5 0 1 0 6.5 5 1.5 1.5 0 0 0 5 3.5m7.5 7.5A1.5 1.5 0 1 1 11 9.5a1.5 1.5 0 0 1 1.5 1.5M11 3.5A1.5 1.5 0 1 0 12.5 5 1.5 1.5 0 0 0 11 3.5" class="cls-1"/></svg>`,
};
export const function16X16: {
  name: 'function_16_x_16';
  data: string;
} = {
  name: 'function_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 12.643h-1.572l-.898-1.283-.923 1.283h-1.54l1.658-2.146-1.632-2.14h1.572l.883 1.258.888-1.258h1.545l-1.635 2.111ZM9.544 4.667H9.31a3 3 0 0 0-.394-.1 2.5 2.5 0 0 0-.483-.05 1.32 1.32 0 0 0-.832.241 1.33 1.33 0 0 0-.405.895l-.128.937h1.846v1.282H6.812l-.376 2.462a3.6 3.6 0 0 1-.462 1.357 2.6 2.6 0 0 1-.784.808 3 3 0 0 1-.938.387A4.8 4.8 0 0 1 3.184 13q-.275 0-.629-.03A3.5 3.5 0 0 1 2 12.892v-1.815h.12a.56.56 0 0 0 .424.244 2.5 2.5 0 0 0 .5.052 1.3 1.3 0 0 0 .898-.29 1.6 1.6 0 0 0 .424-.985l.33-2.226H3.256V6.59H5.05l.178-1.162a2.94 2.94 0 0 1 .444-1.244 2.5 2.5 0 0 1 .76-.734 2.6 2.6 0 0 1 .94-.356A5.6 5.6 0 0 1 8.357 3q.294 0 .588.025t.599.076Z" class="cls-1"/></svg>`,
};
export const gaugeSimple16X16: {
  name: 'gauge_simple_16_x_16';
  data: string;
} = {
  name: 'gauge_simple_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.969 5.196a1.76 1.76 0 0 1 1.142-.49 1.76 1.76 0 0 1-.49 1.142L9.205 8.263l.008.025.065.184.03.093a1.4 1.4 0 0 1 .032.295 1.385 1.385 0 0 1-2.769 0 1.3 1.3 0 0 1 .033-.294l.034-.11.055-.16.012-.033.014-.014a1.4 1.4 0 0 1 .625-.625l.015-.015.033-.011.16-.055.11-.035a1.3 1.3 0 0 1 .588 0l.11.035.16.055.033.011ZM14 8.86a5.98 5.98 0 0 1-1.799 4.28l-1.309-1.308a4.085 4.085 0 0 0 .83-4.78l.55-.55a2.6 2.6 0 0 0 .64-1.082A5.97 5.97 0 0 1 14 8.86m-6-6a5.998 5.998 0 0 0-4.201 10.28l1.309-1.308a4.14 4.14 0 0 1 4.644-6.725l.564-.564a2.6 2.6 0 0 1 1.07-.635A5.97 5.97 0 0 0 8 2.86" class="cls-1"/></svg>`,
};
export const gridThreeByThree16X16: {
  name: 'grid_three_by_three_16_x_16';
  data: string;
} = {
  name: 'grid_three_by_three_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 3v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1m4 9H4v-2h2Zm.001-2.999H4V7h2.001Zm0-3.001H4V4h2.001ZM9 12H7v-2h2Zm0-2.999H7V7h2ZM9 6H7V4h2Zm3 6h-2v-2h2Zm.001-2.999H10V7h2.001Zm0-3.001H10V4h2.001Z" class="cls-1"/></svg>`,
};
export const gridTwoByTwo16X16: {
  name: 'grid_two_by_two_16_x_16';
  data: string;
} = {
  name: 'grid_two_by_two_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 9h3v3H4Zm5 0h3v3H9ZM4 4h3v3H4Zm5 0h3v3H9ZM2 14h12V2H2Z" class="cls-1"/></svg>`,
};
export const hammer16X16: {
  name: 'hammer_16_x_16';
  data: string;
} = {
  name: 'hammer_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9 14H6V8h3ZM8.875 2H6.723A1.99 1.99 0 0 1 5 3a2.49 2.49 0 0 1-2-1H2v4h1a1.8 1.8 0 0 1 1.5-1C5.551 5 5.997 6.99 6 7h3c.333-1.539 1-2.436 1.741-2.436C12.222 4.564 14 6.615 14 6.615S13 2 8.875 2" class="cls-1"/></svg>`,
};
export const hashtag16X16: {
  name: 'hashtag_16_x_16';
  data: string;
} = {
  name: 'hashtag_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m7.76 14 .752-2.914H6.045L5.299 14H3.532l.746-2.914H2v-1.72h2.712l.701-2.807H2.947v-1.72h2.91L6.567 2h1.766l-.71 2.838h2.46L10.8 2h1.768l-.717 2.838H14v1.72h-2.599l-.706 2.807h2.374v1.72h-2.807L9.501 14ZM6.447 9.392h2.506l.72-2.85H7.167Z" class="cls-1"/></svg>`,
};
export const home16X16: {
  name: 'home_16_x_16';
  data: string;
} = {
  name: 'home_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.988 2 2.5 9H4v5h3v-3h2v3h3V9h1.5z" class="cls-1"/></svg>`,
};
export const horizontalTriangleOutline16X16: {
  name: 'horizontal_triangle_outline_16_x_16';
  data: string;
} = {
  name: 'horizontal_triangle_outline_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2.05 2v12l11.4-6zM4 5.313 9.156 8 4 10.688z" class="cls-1"/></svg>`,
};
export const hourglass16X16: {
  name: 'hourglass_16_x_16';
  data: string;
} = {
  name: 'hourglass_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.774 13.4h-.047v-.49h-.404a2.5 2.5 0 0 0 .355-1.258c0-1.826-2.083-2.886-2.083-3.652s2.083-1.826 2.083-3.652a2.5 2.5 0 0 0-.355-1.257h.404V2.6h.047a.556.556 0 0 0 .499-.6H4.727a.556.556 0 0 0 .499.6h.047v.49h.404a2.5 2.5 0 0 0-.355 1.258c0 1.826 2.083 2.87 2.083 3.652s-2.083 1.826-2.083 3.652a2.5 2.5 0 0 0 .355 1.257h-.404v.491h-.047a.556.556 0 0 0-.499.6h6.546a.556.556 0 0 0-.499-.6M8 12.957c-1.565 0-1.975-.585-1.975-1.305a7.2 7.2 0 0 1 1.723-.656c.268 0 .289-3.513 0-3.779l-.988-1h2.454l-.962 1c-.268.286-.275 3.779 0 3.779a7.7 7.7 0 0 1 1.738.656c0 .72-.409 1.305-1.99 1.305" class="cls-1"/></svg>`,
};
export const indent16X16: {
  name: 'indent_16_x_16';
  data: string;
} = {
  name: 'indent_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m2.5 7.5 1 2.5-1 2.5 5-2.5zM2 3h12v2H2zM9 7h5v2H9zM9 11h5v2H9z" class="cls-1"/></svg>`,
};
export const indeterminantCheckbox16X16: {
  name: 'indeterminant_checkbox_16_x_16';
  data: string;
} = {
  name: 'indeterminant_checkbox_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0-1H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M4 4v8h8V4Zm6 6H6V6h4Z" class="cls-1"/></svg>`,
};
export const info16X16: {
  name: 'info_16_x_16';
  data: string;
} = {
  name: 'info_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.415 7.75v3.69H6.376v1.576h4.24V11.44H9.6V6.175H6.376V7.75Zm.276-2.698a1.19 1.19 0 0 0 2.035-.838 1.16 1.16 0 0 0-.346-.846 1.193 1.193 0 0 0-1.693 0 1.16 1.16 0 0 0-.35.846 1.14 1.14 0 0 0 .354.838" class="cls-1"/></svg>`,
};
export const infoCircle16X16: {
  name: 'info_circle_16_x_16';
  data: string;
} = {
  name: 'info_circle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m-.697 2.28a.95.95 0 0 1 1.35 0 .93.93 0 0 1 .276.675.952.952 0 0 1-1.905 0 .92.92 0 0 1 .279-.674M9.7 12H6.3v-1.264h.833V7.777H6.3V6.513h2.584v4.223H9.7Z" class="cls-1"/></svg>`,
};
export const inwardSquaresThree16X16: {
  name: 'inward_squares_three_16_x_16';
  data: string;
} = {
  name: 'inward_squares_three_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 10h2v2H4zm-1 3h1v-1H3zm7-7H6v4h4zM3 3v4h2V5h6v6H9v2h4V3z" class="cls-1"/></svg>`,
};
export const italicI16X16: {
  name: 'italic_i_16_x_16';
  data: string;
} = {
  name: 'italic_i_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 16 16"><path d="M8.99 13.802H4.38l.258-1.133h1.523l2.17-9.367H6.808l.258-1.133h4.61l-.258 1.133H9.895l-2.17 9.367h1.523z"/></svg>`,
};
export const key16X16: {
  name: 'key_16_x_16';
  data: string;
} = {
  name: 'key_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m12.045 7.348-.652-.652 1.444-.14Zm-3.818.698-4.912 4.912-.395-.396 4.12-4.12Zm4.734-2.918-1.697.136-.395-.395L11 3.176l.72-.067 1.304 1.304Zm-3.524-.386-.651-.653.791-.791Zm-1.955-.653v2.607l-5.074 5.075L2 12.946l.791.791 1.432.129.326-.326v-.652l.652-.652h.652l.326-.325v-.652h.651l.978-.978.014-.652.312-.326h.652l.652-.651h2.607l1.676-1.676L14 4.089l-1.955-1.955-2.887.28Z" class="cls-1"/></svg>`,
};
export const laptop16X16: {
  name: 'laptop_16_x_16';
  data: string;
} = {
  name: 'laptop_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 11V3H3v8H2v2h12v-2Zm-2 1H5v-1h6Zm1-1.996H4V4h8Z" class="cls-1"/></svg>`,
};
export const layerGroup16X16: {
  name: 'layer_group_16_x_16';
  data: string;
} = {
  name: 'layer_group_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m3.555 9.546.89-.445 5.333 2.667 1.778-.89.889.449v1.33L9.778 13.99l-6.223-3.11Zm0-6.222L6.222 1.99l6.223 3.112v1.333L9.778 7.768l-6.223-3.11Zm0 3.11.89-.444 5.333 2.667 1.778-.89.889.448v1.33L9.778 10.88 3.555 7.768Z" class="cls-1"/></svg>`,
};
export const lightbulb16X16: {
  name: 'lightbulb_16_x_16';
  data: string;
} = {
  name: 'lightbulb_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 5.53C12 3.584 10.206 2 8 2S4 3.583 4 5.53c0 .736.256 1.44.74 2.04.801.99 1.285 2.456 1.555 3.427h3.41c.27-.97.754-2.437 1.556-3.428.483-.598.739-1.303.739-2.038M9.138 14H6.862l-.569-1.001v-.3l.285-.15-.285-.15v-.401h3.414v.4l-.285.15.285.15V13z" class="cls-1"/></svg>`,
};
export const lightningBolt16X16: {
  name: 'lightning_bolt_16_x_16';
  data: string;
} = {
  name: 'lightning_bolt_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4.732 7.953 6.909 2h3.636L8.364 7.013h2.909L4.727 14l2.21-6.049Z" class="cls-1"/></svg>`,
};
export const link16X16: {
  name: 'link_16_x_16';
  data: string;
} = {
  name: 'link_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.465 5.592A2.91 2.91 0 0 1 9.963 7.02l-1.06 1.065c-.053-.103-.095-.192-.144-.276a1.48 1.48 0 0 0-1.277-.769 1.43 1.43 0 0 0-.977.394c-.75.694-1.469 1.421-2.165 2.168a1.43 1.43 0 0 0 .054 2.038 1.5 1.5 0 0 0 1.039.432 1.28 1.28 0 0 0 .953-.417c.103-.11.435-.44.81-.805a3.46 3.46 0 0 0 1.908.188c-1.006 1.035-2.179 2.187-2.996 2.38a3 3 0 0 1-.693.082 2.91 2.91 0 0 1-2.182-4.842A47 47 0 0 1 5.53 6.356a2.83 2.83 0 0 1 1.935-.764M10.583 2.5a3 3 0 0 0-.69.081 10.4 10.4 0 0 0-2.996 2.377 3.5 3.5 0 0 1 .568-.054 3.6 3.6 0 0 1 1.31.249c.38-.332.701-.646.875-.834a1.22 1.22 0 0 1 .913-.395 1.51 1.51 0 0 1 1.074.469 1.433 1.433 0 0 1 .022 2.005c-.7.743-1.42 1.47-2.165 2.167a1.42 1.42 0 0 1-.975.395 1.48 1.48 0 0 1-1.28-.768c-.048-.085-.089-.175-.151-.298L6.043 8.987a2.88 2.88 0 0 0 2.493 1.42 2.8 2.8 0 0 0 1.93-.76 54 54 0 0 0 2.266-2.266A2.911 2.911 0 0 0 10.583 2.5" class="cls-1"/></svg>`,
};
export const linkCancel16X16: {
  name: 'link_cancel_16_x_16';
  data: string;
} = {
  name: 'link_cancel_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9.202 9.45a2.64 2.64 0 0 1 .687 2.519l-1.364.002c.032-.1.062-.183.085-.269a1.34 1.34 0 0 0-.326-1.312 1.3 1.3 0 0 0-.88-.374 38 38 0 0 0-2.779.002 1.3 1.3 0 0 0-1.273 1.341 1.37 1.37 0 0 0 .39.944 1.16 1.16 0 0 0 .878.344c.137-.005.562-.002 1.036.004a3.14 3.14 0 0 0 1.104 1.344 8.1 8.1 0 0 1-3.45-.395 2.7 2.7 0 0 1-.496-.392A2.64 2.64 0 0 1 4.52 8.702a43 43 0 0 1 2.951-.003 2.56 2.56 0 0 1 1.731.751m3.984.017a2.7 2.7 0 0 0-.495-.39 9.4 9.4 0 0 0-3.447-.398 3 3 0 0 1 .4.33 3.3 3.3 0 0 1 .68 1c.457.031.864.035 1.096.027a1.1 1.1 0 0 1 .839.331 1.37 1.37 0 0 1 .389.99 1.3 1.3 0 0 1-1.272 1.3c-.926.028-1.854.033-2.78.002a1.3 1.3 0 0 1-.878-.372 1.35 1.35 0 0 1-.328-1.313c.023-.086.054-.17.093-.289l-1.371.031a2.61 2.61 0 0 0 .688 2.51 2.55 2.55 0 0 0 1.726.751c.968.033 1.94.025 2.908 0a2.641 2.641 0 0 0 1.752-4.51m-2.701-3.208L8.71 4.485l1.775-1.775-.71-.71L8 3.775 6.225 2l-.71.71L7.29 4.485 5.515 6.259l.71.71L8 5.195l1.775 1.774Z" class="cls-1"/></svg>`,
};
export const list16X16: {
  name: 'list_16_x_16';
  data: string;
} = {
  name: 'list_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 13H2v-2h2Zm10-2H6v2h8ZM4 7H2v2h2Zm10 0H6v2h8ZM4 3H2v2h2Zm10 0H6v2h8Z" class="cls-1"/></svg>`,
};
export const listTree16X16: {
  name: 'list_tree_16_x_16';
  data: string;
} = {
  name: 'list_tree_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10 5v2h4v2h-4v2h4v2H8V5H5V3h9v2ZM2 5h2V3H2Zm5 6H5v2h2Zm0-4H5v2h2Z" class="cls-1"/></svg>`,
};
export const listTreeDatabase16X16: {
  name: 'list_tree_database_16_x_16';
  data: string;
} = {
  name: 'list_tree_database_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.953 11.81c.013-.011.032-.02.046-.031v.917c0 .33-.523.678-1.42.953a8 8 0 0 1-.694.178 16 16 0 0 1-3.382.328 16 16 0 0 1-3.38-.328 9 9 0 0 1-.693-.179c-.898-.274-1.42-.622-1.42-.952v-.917c.012.01.031.02.045.03a2.3 2.3 0 0 0 .332.218l.03.017a4 4 0 0 0 .46.202l.01.005.1.037q.081.026.164.05.139.047.283.09.048.016.1.031l.058.015q.277.072.58.132.063.014.13.026.322.063.666.11l.134.017q.315.041.646.072l.104.01q.364.031.731.049l.166.007q.378.015.754.016.375-.001.754-.016l.164-.007q.37-.018.734-.048l.102-.011q.33-.03.649-.072.067-.008.134-.017.343-.048.664-.11.068-.012.132-.026.3-.06.577-.13.031-.01.063-.017c.034-.009.064-.021.099-.031.098-.028.189-.059.283-.09.052-.017.11-.032.16-.05q.053-.018.103-.037l.012-.005a4 4 0 0 0 .457-.202q.018-.01.032-.018a2.5 2.5 0 0 0 .33-.216m-5.45-2.946c-3.237 0-5.492.767-5.492 1.457 0 .33.523.679 1.42.952q.153.048.325.091.176.046.368.088a16 16 0 0 0 3.38.327 16 16 0 0 0 3.38-.327 9 9 0 0 0 .695-.18C13.477 11 14 10.652 14 10.322c0-.69-2.257-1.457-5.497-1.457M14 6V5H5V3h2V2H2v1h2v5.581a10 10 0 0 1 1-.255V6h3v2h6V7H9V6Z" class="cls-1"/></svg>`,
};
export const lock16X16: {
  name: 'lock_16_x_16';
  data: string;
} = {
  name: 'lock_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 8V7a3.89 3.89 0 0 0-4-4 3.82 3.82 0 0 0-2.81 1.078A4.35 4.35 0 0 0 4.062 7v1H3v6h10V8ZM6.062 6.986a2.4 2.4 0 0 1 .566-1.516A1.83 1.83 0 0 1 8 5a1.883 1.883 0 0 1 2 2v1H6.062Z" class="cls-1"/></svg>`,
};
export const magnifyingGlass16X16: {
  name: 'magnifying_glass_16_x_16';
  data: string;
} = {
  name: 'magnifying_glass_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m13.073 12.29-2.926-2.926a3.971 3.971 0 1 0-.783.783l2.927 2.926ZM7.01 9.84a2.83 2.83 0 1 1 2.83-2.83 2.833 2.833 0 0 1-2.83 2.83" class="cls-1"/></svg>`,
};
export const markdown16X16: {
  name: 'markdown_16_x_16';
  data: string;
} = {
  name: 'markdown_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14.25 3H1.75a.74.74 0 0 0-.75.73v8.54a.74.74 0 0 0 .75.73h12.5a.74.74 0 0 0 .75-.73V3.73a.74.74 0 0 0-.75-.73m-6.285 7.059h-.991V7.773L5.982 9.35l-.99-1.577v2.286H4V5.934h.91L5.982 7.51l1.073-1.576h.91Zm2.459.007L8.848 7.945h1.1V5.934h.99v2.01H12Z" class="cls-1"/></svg>`,
};
export const messageBot16X16: {
  name: 'message_bot_16_x_16';
  data: string;
} = {
  name: 'message_bot_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14.985 2.016c.286.284.645.44 1.015.485-.369.044-.728.2-1.012.484a1.7 1.7 0 0 0-.487 1.013c-.044-.37-.2-.73-.487-1.015A1.7 1.7 0 0 0 13 2.498c.369-.044.728-.2 1.012-.484.286-.285.442-.644.487-1.013.044.37.2.73.486 1.015M13 7.994c0 2.208-2.239 3.997-5 3.997S3 10.2 3 7.994s2.239-3.996 5-3.996 5 1.79 5 3.996m-7 0a1 1 0 1 0 0-1.999 1 1 0 0 0 0 2m4.5 1.008h-5s.917 1.481 2.5 1.481c1.514 0 2.5-1.48 2.5-1.48m.5-2.007a1 1 0 1 0-1.999.001 1 1 0 0 0 1.999 0m3.692 2.759c-.878 2.452-3.541 4.235-6.692 4.235a8 8 0 0 1-1.782-.204L3 15.5v-3.3c-.764-.673-1.363-1.527-1.692-2.446C.696 9.418 0 8.76 0 7.994S.696 6.57 1.308 6.235C2.186 3.783 4.849 2 8 2c1.075 0 2.09.214 3 .585V1h1v2.078c1.267.758 2.23 1.862 2.692 3.156.612.335 1.308.993 1.308 1.76s-.696 1.423-1.308 1.759M14 7.994C14 5.24 11.308 3 8 3S2 5.24 2 7.994s2.692 4.996 6 4.996 6-2.241 6-4.996" class="cls-1"/></svg>`,
};
export const microphone16X16: {
  name: 'microphone_16_x_16';
  data: string;
} = {
  name: 'microphone_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6 8V4a2 2 0 1 1 4 0v4a2 2 0 0 1-4 0m6 0v-.5a.5.5 0 1 0-1 0V8a3 3 0 1 1-6 0v-.5a.5.5 0 1 0-1 0V8c0 1.859 1.28 3.411 3 3.858V14h2v-2.142c1.72-.447 3-2 3-3.858" class="cls-1"/><path d="M6 8V4a2 2 0 1 1 4 0v4a2 2 0 0 1-4 0m6 0v-.5a.5.5 0 1 0-1 0V8a3 3 0 1 1-6 0v-.5a.5.5 0 1 0-1 0V8c0 1.859 1.28 3.411 3 3.858V14h2v-2.142c1.72-.447 3-2 3-3.858" class="cls-1"/></svg>`,
};
export const minus16X16: {
  name: 'minus_16_x_16';
  data: string;
} = {
  name: 'minus_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 7h8v2H4z" class="cls-1"/></svg>`,
};
export const minusWide16X16: {
  name: 'minus_wide_16_x_16';
  data: string;
} = {
  name: 'minus_wide_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3 7h10v2H3z" class="cls-1"/></svg>`,
};
export const mobile16X16: {
  name: 'mobile_16_x_16';
  data: string;
} = {
  name: 'mobile_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.462 2.077H4.538A.54.54 0 0 0 4 2.615v10.77a.54.54 0 0 0 .538.538h5.924a.54.54 0 0 0 .538-.538V2.615a.54.54 0 0 0-.538-.538M10 12H5V3h5Z" class="cls-1"/></svg>`,
};
export const mountainSun16X16: {
  name: 'mountain_sun_16_x_16';
  data: string;
} = {
  name: 'mountain_sun_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m13.457 10.097-1.468-3.011-1.195-1.026-.677.48-2.343-3.556L4.688 8.14l-1.204-.678-1.468 1.543L1 13h14zm-10.478-.2-.939 1.047.372-1.652.975-.993 2.722 3.04zm5.924.764L7.181 9.335l.17-1.958-2.192.896L7.605 4.19 9.4 7.06l-.11.943 1.197-1.038 2.228 4.345zM4.5 4.487a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" class="cls-1"/></svg>`,
};
export const ni16X16: {
  name: 'ni_16_x_16';
  data: string;
} = {
  name: 'ni_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.172 4c1.675 0 3 1.354 3 3.103V13h-3V7h-3V4zm-3 9h-3V7h3zm10.656-9v9c-1.681 0-3-1.378-3-3V4z" class="cls-1"/></svg>`,
};
export const notebook16X16: {
  name: 'notebook_16_x_16';
  data: string;
} = {
  name: 'notebook_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 2h1v3h-1Zm0 8h1V6h-1Zm0 4h1v-3h-1ZM4 7h6V6H4Zm0-2h6V4H4ZM2 2h10v12H2Z" class="cls-1"/></svg>`,
};
export const numberList16X16: {
  name: 'number_list_16_x_16';
  data: string;
} = {
  name: 'number_list_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 16 16"><path d="M14 11H6v2h8zm0-4H6v2h8zm0-4H6v2h8zM1.999 4.644h.73V2.302h-.585v-.271c.295-.05.505-.13.681-.235h.32v2.848h.656v.346H1.999zM1.804 9.509c.951-.932 1.501-1.521 1.501-2.037 0-.365-.2-.621-.605-.621-.265 0-.496.17-.676.381l-.235-.226c.265-.3.551-.495.961-.495.591 0 .961.375.961.936 0 .621-.561 1.196-1.336 1.987.174-.016.37-.026.535-.026h.956v.355H1.804zM1.733 13.884l.21-.271c.19.201.44.376.816.376.385 0 .661-.226.661-.581 0-.38-.26-.635-1.021-.635v-.315c.676 0 .906-.261.906-.596 0-.306-.21-.501-.55-.501-.266 0-.491.136-.681.32l-.221-.26c.246-.23.541-.4.916-.4.556 0 .956.295.956.811 0 .386-.23.631-.576.761v.021c.385.09.691.37.691.811 0 .565-.471.91-1.056.91a1.36 1.36 0 0 1-1.051-.451"/></svg>`,
};
export const outdent16X16: {
  name: 'outdent_16_x_16';
  data: string;
} = {
  name: 'outdent_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m7.5 12.5-1-2.5 1-2.5-5 2.5zM2 3h12v2H2zM9 7h5v2H9zM9 11h5v2H9z" class="cls-1"/></svg>`,
};
export const outwardSquaresThree16X16: {
  name: 'outward_squares_three_16_x_16';
  data: string;
} = {
  name: 'outward_squares_three_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9 9H7V7h2zm-6 4h4V9H3zM3 3v4h2V5h6v6H9v2h4V3zm7 3H9v1h1z" class="cls-1"/></svg>`,
};
export const paperPlane16X16: {
  name: 'paper_plane_16_x_16';
  data: string;
} = {
  name: 'paper_plane_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m1 12.5 2-4 6-1-6-1-2-4 14 5z" class="cls-1"/></svg>`,
};
export const paperclip16X16: {
  name: 'paperclip_16_x_16';
  data: string;
} = {
  name: 'paperclip_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.5 14C6.406 14 5 12.393 5 10V5c0-1.822.981-3 2.5-3S10 3.178 10 5v3.98c0 1.328-.505 2-1.5 2s-1.5-.672-1.5-2V6h1v2.98c0 1 .266 1 .5 1s.5 0 .5-1V5c0-.602-.146-2-1.5-2S6 4.398 6 5v5c0 1.384.654 3 2.5 3s2.5-1.616 2.5-3V6h1v4c0 2.393-1.406 4-3.5 4"/></svg>`,
};
export const paste16X16: {
  name: 'paste_16_x_16';
  data: string;
} = {
  name: 'paste_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9 5V3H3v6h2v1H2V2h8v3ZM6 6v8h8V6Z" class="cls-1"/></svg>`,
};
export const pause16X16: {
  name: 'pause_16_x_16';
  data: string;
} = {
  name: 'pause_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 3h3v10H4zM9 3h3v10H9z" class="cls-1"/></svg>`,
};
export const pencil16X16: {
  name: 'pencil_16_x_16';
  data: string;
} = {
  name: 'pencil_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.118 2.793 4.84 8.076 2.5 13.5l5.43-2.335 5.278-5.284a1 1 0 0 0-.001-1.414l-1.675-1.674a1 1 0 0 0-1.414 0m-5.76 9.154-.31-.309 1.427-3.296.53 1.652 1.648.543z" class="cls-1"/></svg>`,
};
export const play: {
  name: 'play';
  data: string;
} = {
  name: 'play',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2.05 2v12l11.4-6z" class="cls-1"/></svg>`,
};
export const potWithLid16X16: {
  name: 'pot_with_lid_16_x_16';
  data: string;
} = {
  name: 'pot_with_lid_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11 4V2H5v2H2v1h12V4ZM6 4V3h4v1Zm-4 9h1v1h10v-1h1V6H2Z" class="cls-1"/></svg>`,
};
export const question16X16: {
  name: 'question_16_x_16';
  data: string;
} = {
  name: 'question_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11.303 5.594a3.3 3.3 0 0 1-.195 1.176 2.6 2.6 0 0 1-.549.885 4 4 0 0 1-.852.672 7.5 7.5 0 0 1-1.121.54v1.501H6.27V8.15q.467-.125.845-.256a3.2 3.2 0 0 0 .793-.429 2.1 2.1 0 0 0 .608-.612 1.45 1.45 0 0 0 .22-.791 1.04 1.04 0 0 0-.423-.939 2.16 2.16 0 0 0-1.195-.28 3.3 3.3 0 0 0-1.068.204 4.9 4.9 0 0 0-1.09.526h-.263V3.566a8 8 0 0 1 1.296-.372A8.2 8.2 0 0 1 7.77 3a4.2 4.2 0 0 1 2.579.718 2.24 2.24 0 0 1 .954 1.876M8.77 13H6.112v-1.737H8.77Z" class="cls-1"/></svg>`,
};
export const rectangleCheckLines16X16: {
  name: 'rectangle_check_lines_16_x_16';
  data: string;
} = {
  name: 'rectangle_check_lines_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3 2v12h10V2zm9 11H4V3h8z" class="cls-2"/><path d="M5 9h6v1H5zM5 11h3v1H5z" class="cls-2"/><path d="M11 4.643 7.591 8 6 6.434l.682-.672.937.923L10.347 4z" class="cls-1"/></svg>`,
};
export const rectangleLines16X16: {
  name: 'rectangle_lines_16_x_16';
  data: string;
} = {
  name: 'rectangle_lines_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3 2v12h10V2zm6 7H5V8h4zm2-2H5V6h6zm0-2H5V4h6z" class="cls-1"/></svg>`,
};
export const runningArrow16X16: {
  name: 'running_arrow_16_x_16';
  data: string;
} = {
  name: 'running_arrow_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m13.45 7.985-7.602 4.013L7.75 8 5.848 3.987zM3.945 2.997 2.05 2 4.9 8l-2.85 6 1.902-1.005L6.325 8z" class="cls-1"/></svg>`,
};
export const screenCheckLines16X16: {
  name: 'screen_check_lines_16_x_16';
  data: string;
} = {
  name: 'screen_check_lines_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3 3H2v8h5v1H5v1h6v-1H9v-1h5V3zm10 7H3V4h10z" class="cls-1"/><path d="M5.743 9 4 7.242l.766-.742.97 1.007L8.273 5 9 5.758zM10 6h2v1h-2zM8 8h4v1H8z" class="cls-1"/></svg>`,
};
export const screenCheckLinesCalendar16X16: {
  name: 'screen_check_lines_calendar_16_x_16';
  data: string;
} = {
  name: 'screen_check_lines_calendar_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6 9H3V3h10v3h1V2H2v8h4zM4 11h2v1H4z" class="cls-1"/><path d="M13 8V7h-1v1H9V7H8v1H7v6h7V8zm0 5H8v-3h5zM5.465 8.052 3.723 6.295l.765-.743.97 1.007 2.538-2.507.727.758zM9.723 5.052h2v1h-2z" class="cls-1"/></svg>`,
};
export const server16X16: {
  name: 'server_16_x_16';
  data: string;
} = {
  name: 'server_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 3H3v3h10ZM9 5H4V4h5ZM3 7v3h10V7Zm6 2H4V8h5Zm3 4H3v-2h10v1a1 1 0 0 1-1 1" class="cls-1"/></svg>`,
};
export const shareNodes16X16: {
  name: 'share_nodes_16_x_16';
  data: string;
} = {
  name: 'share_nodes_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 10c-.601 0-1.134.27-1.5.69L5.954 8.419a2 2 0 0 0 0-.836l4.544-2.273c.367.42.9.691 1.501.691a2 2 0 1 0-1.955-1.582L5.501 6.691C5.134 6.27 4.6 6 4 6a2 2 0 1 0 0 4c.601 0 1.134-.27 1.5-.69l4.545 2.272A2 2 0 1 0 12 10"/></svg>`,
};
export const shieldCheck16X16: {
  name: 'shield_check_16_x_16';
  data: string;
} = {
  name: 'shield_check_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v5.11C2 10.39 8 14 8 14s6-3.281 6-6.89V2Zm4.788 8.2L4 7.388 5.225 6.2l1.553 1.61 4.06-4.01L12 5.013Z" class="cls-1"/></svg>`,
};
export const shieldXmark16X16: {
  name: 'shield_xmark_16_x_16';
  data: string;
} = {
  name: 'shield_xmark_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v5.11C2 10.39 8 14 8 14s6-3.281 6-6.89V2Zm9.5 7.346L10.346 10.5 8 8.154 5.654 10.5 4.5 9.346 6.846 7 4.5 4.654 5.654 3.5 8 5.846 10.346 3.5 11.5 4.654 9.154 7Z" class="cls-1"/></svg>`,
};
export const signalBars16X16: {
  name: 'signal_bars_16_x_16';
  data: string;
} = {
  name: 'signal_bars_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 14H2V2h2Zm3-9H5v9h2Zm3 3H8v6h2Zm3 3h-2v3h2Z" class="cls-1"/></svg>`,
};
export const sineGraph16X16: {
  name: 'sine_graph_16_x_16';
  data: string;
} = {
  name: 'sine_graph_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 12H2v-1.63a4.6 4.6 0 0 0 1.766-1.967c.636-1.06 1.082-1.705 1.902-1.705s1.266.644 1.902 1.705c.615 1.026 1.312 2.189 2.766 2.189s2.15-1.163 2.764-2.189a6.5 6.5 0 0 1 .9-1.267Zm0-6.054a4.6 4.6 0 0 0-1.764 1.967c-.635 1.061-1.08 1.705-1.9 1.705S9.07 8.974 8.434 7.913c-.615-1.026-1.312-2.189-2.766-2.189S3.517 6.887 2.902 7.913A6.5 6.5 0 0 1 2 9.18V4h12Z" class="cls-1"/></svg>`,
};
export const skipArrow16X16: {
  name: 'skip_arrow_16_x_16';
  data: string;
} = {
  name: 'skip_arrow_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 2h-2v12h2zm-4 6.5-8 4v-8z" class="cls-1"/></svg>`,
};
export const sparkleSwirls16X16: {
  name: 'sparkle_swirls_16_x_16';
  data: string;
} = {
  name: 'sparkle_swirls_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><defs><linearGradient id="a" x1="2.044" x2="13.956" y1="8" y2="8" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#009b65"/><stop offset=".5" stop-color="#00a7d2"/><stop offset="1" stop-color="#bb3bff"/></linearGradient></defs><path d="m13.956 7.972-.001.066c-.001.023-.006.068-.006.068a1.038 1.038 0 0 1-2.068-.126c0-.107.045-.33.044-.34.034-.229.07-.458.07-.696A4.735 4.735 0 0 0 5.45 2.571 5.9 5.9 0 0 1 7.968 2a5.99 5.99 0 0 1 5.988 5.972M4.005 9.056c0-.238.036-.467.07-.696-.001-.01.044-.233.044-.34a1.038 1.038 0 0 0-2.068-.126s-.005.045-.006.068l-.001.066A5.99 5.99 0 0 0 8.032 14c.903 0 1.751-.214 2.518-.571a4.735 4.735 0 0 1-6.546-4.373M8 9.594c.915 0 1.706.198 2.078.484-.286-.372-.484-1.163-.484-2.078s.198-1.706.484-2.078c-.372.286-1.163.484-2.078.484s-1.706-.198-2.078-.484c.286.372.484 1.163.484 2.078s-.198 1.706-.484 2.078c.372-.286 1.163-.484 2.078-.484" style="fill:url(#a);stroke-width:0"/></svg>`,
};
export const sparkles16X16: {
  name: 'sparkles_16_x_16';
  data: string;
} = {
  name: 'sparkles_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11.498 2a2.85 2.85 0 0 1-.811 1.69A2.85 2.85 0 0 1 9 4.498a2.85 2.85 0 0 1 1.69.809c.477.476.739 1.076.812 1.693a2.85 2.85 0 0 1 .811-1.69A2.85 2.85 0 0 1 14 4.502a2.85 2.85 0 0 1-1.69-.809A2.84 2.84 0 0 1 11.497 2M7.495 3c-.163 1.355-.737 2.674-1.784 3.719C4.668 7.76 3.352 8.332 2 8.496c1.355.163 2.674.736 3.72 1.78C6.768 11.321 7.343 12.642 7.505 14c.162-1.355.736-2.674 1.784-3.719C10.332 9.24 11.648 8.668 13 8.504c-1.356-.163-2.674-.736-3.72-1.78C8.231 5.679 7.656 4.358 7.495 3" class="cls-1"/></svg>`,
};
export const spinner: {
  name: 'spinner';
  data: string;
} = {
  name: 'spinner',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3.967 7.143h-.762a4.885 4.885 0 0 1 3.938-3.94v.771a4.12 4.12 0 0 0-3.176 3.169M8 2v1.875A4.125 4.125 0 1 1 3.875 8H2a6 6 0 1 0 6-6" class="cls-1"/></svg>`,
};
export const squareCheck16X16: {
  name: 'square_check_16_x_16';
  data: string;
} = {
  name: 'square_check_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v12h12V2Zm4.788 9.2L4 8.388 5.225 7.2l1.553 1.61 4.06-4.01L12 6.013Z" class="cls-1"/></svg>`,
};
export const squareT16X16: {
  name: 'square_t_16_x_16';
  data: string;
} = {
  name: 'square_t_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v12h12V2Zm9.033 4.199-.016-.076a2.34 2.34 0 0 0-.497-1.18 2.1 2.1 0 0 0-1.281-.26h-.56v5.941c0 .552.11.718.176.768a1.8 1.8 0 0 0 .88.196l.09.006V12H6.193v-.405l.09-.007c.59-.046.8-.144.87-.218.06-.06.158-.255.158-.884V4.683h-.565a2.2 2.2 0 0 0-1.274.262 2 2 0 0 0-.498 1.174l-.015.08H4.49L4.565 4h6.859l.07 2.199Z" class="cls-1"/></svg>`,
};
export const squareX16X16: {
  name: 'square_x_16_x_16';
  data: string;
} = {
  name: 'square_x_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3 3v10h10V3zm8 7.01-.99.99L8 8.99 5.99 11 5 10.01 7.01 8 5 5.99 5.99 5 8 7.01 10.01 5l.99.99L8.99 8z" class="cls-1"/></svg>`,
};
export const star8Point16X16: {
  name: 'star_8_point_16_x_16';
  data: string;
} = {
  name: 'star_8_point_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.756 6.872 15 8.002 10.754 9.13l1.722 3.335-3.31-1.74L8.046 15l-1.118-4.276-3.312 1.736 1.727-3.332L1 7.996 5.343 6.87 3.621 3.535l3.308 1.74L8.052 1l1.12 4.276 3.31-1.734z" class="cls-1"/></svg>`,
};
export const stopSquare16X16: {
  name: 'stop_square_16_x_16';
  data: string;
} = {
  name: 'stop_square_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3 3h10v10H3z" class="cls-1"/></svg>`,
};
export const systemlink16X16: {
  name: 'systemlink_16_x_16';
  data: string;
} = {
  name: 'systemlink_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.357 9.143H4.786V6.79c0-.927.442-1.714 1.262-2.211C6.674 4.2 7.505 4 8.451 4h5.335v2.571H8.69c-.911.124-1.262.548-1.333 1.267z" class="cls-1"/><path d="M8.643 7.857h2.571v2.352c0 .927-.442 1.714-1.262 2.211-.626.38-1.457.58-2.403.58H2.214v-2.571H7.31c.911-.124 1.262-.548 1.333-1.267z" class="cls-1"/></svg>`,
};
export const t16X16: {
  name: 't_16_x_16';
  data: string;
} = {
  name: 't_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M5.684 13v-.729l.221-.018c.764-.058.947-.19.985-.229.026-.026.157-.202.157-.992V4.078H6.48a2.46 2.46 0 0 0-1.477.291 2.26 2.26 0 0 0-.563 1.36l-.038.196h-.797L3.704 3h8.6l.092 2.925h-.784l-.021-.095a2.8 2.8 0 0 0-.589-1.466c-.147-.131-.523-.286-1.48-.286H8.96V11.2c0 .679.138.819.165.84a2.1 2.1 0 0 0 1.01.213l.223.018V13Z" class="cls-1"/></svg>`,
};
export const tablet16X16: {
  name: 'tablet_16_x_16';
  data: string;
} = {
  name: 'tablet_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12.5 2h-9a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5M8 13.25a.75.75 0 1 1 .75-.75.75.75 0 0 1-.75.75M12 11H4V3h8Z" class="cls-1"/></svg>`,
};
export const tag16X16: {
  name: 'tag_16_x_16';
  data: string;
} = {
  name: 'tag_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16"><path d="M8.044 3.588 5.23 3 3 5.229l.588 2.816L8.543 13 13 8.543ZM6.5 6.499a1.082 1.082 0 1 1-.013-1.516A1.07 1.07 0 0 1 6.499 6.5" class="cls-1"/></svg>`,
};
export const tags16X16: {
  name: 'tags_16_x_16';
  data: string;
} = {
  name: 'tags_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16"><path d="M8.044 2.338 5.23 1.75 3 3.979l.588 2.816 4.955 4.955L13 7.293ZM6.5 5.249a1.082 1.082 0 1 1-.013-1.516 1.07 1.07 0 0 1 .013 1.516m6.251 4.794L8.543 14.25 4.257 9.964l-.283-1.369 4.569 4.57L12.207 9.5Z" class="cls-1"/></svg>`,
};
export const targetCrosshairs16X16: {
  name: 'target_crosshairs_16_x_16';
  data: string;
} = {
  name: 'target_crosshairs_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 6.01a2 2 0 1 0 2 2 2 2 0 0 0-2-2m4.9.99A5 5 0 0 0 9 3.1V1H7v2.1A5 5 0 0 0 3.1 7H1v2h2.1A5 5 0 0 0 7 12.9V15h2v-2.1A5 5 0 0 0 12.9 9H15V7ZM8 12a4 4 0 1 1 4-4 4.005 4.005 0 0 1-4 4" class="cls-1"/></svg>`,
};
export const targetCrosshairsProgress16X16: {
  name: 'target_crosshairs_progress_16_x_16';
  data: string;
} = {
  name: 'target_crosshairs_progress_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15 7v2h-2.1A5 5 0 0 1 9 12.9V15H7v-2.108a4.99 4.99 0 0 1-3.898-3.985l-1.52.583 2.003-4 1.998 4L4.11 8.9A3.999 3.999 0 1 0 7 4.13V1h2v2.1A5 5 0 0 1 12.9 7Zm-5 1.01a2 2 0 1 1-2-2 2 2 0 0 1 2 2" class="cls-1"/></svg>`,
};
export const threeCirclesAscendingContainer16X16: {
  name: 'three_circles_ascending_container_16_x_16';
  data: string;
} = {
  name: 'three_circles_ascending_container_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M4 8.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m3 .5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4 .5a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5" class="cls-1"/></svg>`,
};
export const threeDotsLine16X16: {
  name: 'three_dots_line_16_x_16';
  data: string;
} = {
  name: 'three_dots_line_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 6.5A1.5 1.5 0 1 1 6.5 8 1.5 1.5 0 0 1 8 6.5M.5 8A1.5 1.5 0 1 0 2 6.5 1.5 1.5 0 0 0 .5 8m12 0A1.5 1.5 0 1 0 14 6.5 1.5 1.5 0 0 0 12.5 8" class="cls-1"/></svg>`,
};
export const threeVerticalLines16X16: {
  name: 'three_vertical_lines_16_x_16';
  data: string;
} = {
  name: 'three_vertical_lines_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11 3h2v10h-2zM7 3h2v10H7zM3 3h2v10H3z" class="cls-1"/></svg>`,
};
export const thumbDown16X16: {
  name: 'thumb_down_16_x_16';
  data: string;
} = {
  name: 'thumb_down_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 10h-2V3h2zM2 6.554c0 .488.558.923.581 1.158s-.194.503-.194.796c0 .635.51 1.492 1.315 1.492H5.75c.336 0 .525.327.426.648C6.08 10.96 6 11 6 11.5 6 13 7.001 14 8 14a.5.5 0 0 0 .5-.5V12c0-1.5 1.317-1.13 2.5-3V3S8.255 2 6.5 2H5.064C3.68 2 4.034 3.334 3.839 3.404c-.453.162-1.023.676-1.023 1.35 0 .172.145.393.084.486-.123.186-.9.689-.9 1.314" class="cls-1"/></svg>`,
};
export const thumbUp16X16: {
  name: 'thumb_up_16_x_16';
  data: string;
} = {
  name: 'thumb_up_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 7h2v7H2zm12 2.446c0-.488-.558-.923-.581-1.158s.194-.503.194-.796c0-.635-.51-1.492-1.315-1.492H10.25c-.336 0-.525-.327-.426-.648C9.92 5.04 10 5 10 4.5 10 3 8.999 2 8 2a.5.5 0 0 0-.5.5V4c0 1.5-1.317 1.13-2.5 3v6s2.745 1 4.5 1h1.436c1.383 0 1.03-1.334 1.225-1.404.453-.162 1.023-.676 1.023-1.35 0-.172-.145-.393-.084-.486.123-.186.9-.689.9-1.314" class="cls-1"/></svg>`,
};
export const thumbtack16X16: {
  name: 'thumbtack_16_x_16';
  data: string;
} = {
  name: 'thumbtack_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m10 7-.625-5H10V1H5v1h.625L5 7a2 2 0 0 0-2 2h4v4l.5 2 .5-2V9h4a2 2 0 0 0-2-2" class="cls-1"/></svg>`,
};
export const tileSize16X16: {
  name: 'tile_size_16_x_16';
  data: string;
} = {
  name: 'tile_size_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 8h6v6H2Zm0-6v5h2V4h8v8H9v2h5V2Z" class="cls-1"/></svg>`,
};
export const times16X16: {
  name: 'times_16_x_16';
  data: string;
} = {
  name: 'times_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 9.103 5.102 12 4 10.897 6.898 8 4 5.103 5.102 4 8 6.897 10.898 4 12 5.103 9.102 8 12 10.897 10.898 12z" class="cls-1"/></svg>`,
};
export const trash16X16: {
  name: 'trash_16_x_16';
  data: string;
} = {
  name: 'trash_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10 4V2H6v2H3v2h1v8h8V6h1V4Zm-3 9H6V6h1Zm2-9H7V3h2Zm1 9H9V6h1Z" class="cls-1"/></svg>`,
};
export const triangle16X16: {
  name: 'triangle_16_x_16';
  data: string;
} = {
  name: 'triangle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2 2 14h12Zm0 4.875 2.438 4.875H5.586Z" class="cls-1"/></svg>`,
};
export const triangleFilled16X16: {
  name: 'triangle_filled_16_x_16';
  data: string;
} = {
  name: 'triangle_filled_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2 2 14h12z" class="cls-1"/></svg>`,
};
export const triangleTwoLinesHorizontal: {
  name: 'triangle_two_lines_horizontal';
  data: string;
} = {
  name: 'triangle_two_lines_horizontal',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M3.625 8 8 2l4.375 6zM14 12H2v2h12zm0-3H2v2h12z" class="cls-1"/></svg>`,
};
export const trueFalseRectangle16X16: {
  name: 'true_false_rectangle_16_x_16';
  data: string;
} = {
  name: 'true_false_rectangle_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.4 3.003H2.6a1.6 1.6 0 0 0-1.6 1.6v6.8a1.595 1.595 0 0 0 1.6 1.594h10.8a1.595 1.595 0 0 0 1.6-1.594v-6.8a1.6 1.6 0 0 0-1.6-1.6M7.587 6.58H6.141v3.736H4.946V6.58H3.5v-.896h4.087Zm4.913 0h-2.13v.862h1.974v.896H10.37v1.978H9.181V5.684H12.5Z" class="cls-1"/></svg>`,
};
export const twoSquaresInBrackets: {
  name: 'two_squares_in_brackets';
  data: string;
} = {
  name: 'two_squares_in_brackets',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M4 4h5v5H4zm6 3v3H7v2h5V7zM5 3V2H2v12h3v-1H3V3zm8-1h-2v1h2v10h-2v1h3V2z" class="cls-1"/></svg>`,
};
export const twoTrianglesBetweenLines: {
  name: 'two_triangles_between_lines';
  data: string;
} = {
  name: 'two_triangles_between_lines',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M1.11 2.11v12h2v-12zm12 0v12h2v-12zm-6 8.974-3-3 3-3zm1.925-5.948 3 3-3 3z" class="cls-1"/></svg>`,
};
export const unlink16X16: {
  name: 'unlink_16_x_16';
  data: string;
} = {
  name: 'unlink_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6.126 8.585c-.581.123-1.117.241-1.362.303a1.55 1.55 0 0 0-1.182 1.51l.01.155.021.193a1.7 1.7 0 0 0 .216.54l.02.038.105.134.127.144.054.047a1.5 1.5 0 0 0 .992.36h.049a1.3 1.3 0 0 0 .224-.034l.03.015.006-.001q.694-.134 1.387-.287l.343 1.538c-.488.11-.976.221-1.467.314a3 3 0 0 1-.571.053 3.15 3.15 0 0 1-2.99-2.258l-.011-.045a3 3 0 0 1-.076-.35 3 3 0 0 1-.03-.206l-.004-.089a3 3 0 0 1-.016-.336A3.16 3.16 0 0 1 4.35 7.356c.272-.068.808-.203.802-.206l.623-.137Zm4.31-1.544-.353 1.575c.737.176 1.38.334 1.413.346a1.51 1.51 0 0 1 .789.768l.029.066.053.185.038.164.002.045a1.7 1.7 0 0 1-.035.58l-.064.185-.056.142a1.55 1.55 0 0 1-1.4.893 1.7 1.7 0 0 1-.313-.03 55 55 0 0 1-1.15-.24l-.347 1.55.406.097-.013-.017c.276.057.55.118.826.173a3 3 0 0 0 .578.056 3.19 3.19 0 0 0 2.811-1.74 3 3 0 0 0 .129-.311l.033-.083.061-.197a3 3 0 0 0 .082-.351l.008-.044a3.13 3.13 0 0 0-2.281-3.513c-.297-.077-.777-.19-1.245-.299M7.932 2.393 6.875 6.075h.75l.3 3.032 1.2-3.782h-.75Z" class="cls-1"/></svg>`,
};
export const unlock16X16: {
  name: 'unlock_16_x_16';
  data: string;
} = {
  name: 'unlock_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6.062 8V5.986a2.4 2.4 0 0 1 .566-1.516A1.83 1.83 0 0 1 8 4a1.883 1.883 0 0 1 2 2h2a3.89 3.89 0 0 0-4-4 3.82 3.82 0 0 0-2.81 1.078A4.35 4.35 0 0 0 4.062 6v2H3v6h10V8Z" class="cls-1"/></svg>`,
};
export const upRightFromSquare16X16: {
  name: 'up_right_from_square_16_x_16';
  data: string;
} = {
  name: 'up_right_from_square_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 10.828V12H4V8h1.172l2-2H2v8h8V8.828z" class="cls-1"/><path d="m14.042 1.97-2.063 6.281-.49-2.344-4.117 4.122-1.414-1.414 4.102-4.102-2.324-.504z" class="cls-1"/></svg>`,
};
export const upload16X16: {
  name: 'upload_16_x_16';
  data: string;
} = {
  name: 'upload_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 9v5H2V9h1v4h10V9ZM7.982 2 5 7.9l2.004-1.312L7 11h2V6.613L11 7.9Z" class="cls-1"/></svg>`,
};
export const user16X16: {
  name: 'user_16_x_16';
  data: string;
} = {
  name: 'user_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.004 2a2.18 2.18 0 0 1 2.184 2.182v1.09c.647 0 .378.932 0 1.455a4 4 0 0 1-.335.364 9 9 0 0 1-.31.742l.208 1.076h.437l2.75 1.527A2.15 2.15 0 0 1 14 12.291V14H2v-1.673a2.16 2.16 0 0 1 1.063-1.869l2.758-1.55h.437l.21-1.068a9 9 0 0 1-.312-.749 4 4 0 0 1-.335-.364c-.378-.523-.647-1.454 0-1.454v-1.09A2.18 2.18 0 0 1 8.004 2" class="cls-1"/></svg>`,
};
export const watch16X16: {
  name: 'watch_16_x_16';
  data: string;
} = {
  name: 'watch_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m12.57 7.28-.06.013a4.56 4.56 0 0 0-1.38-2.609V3.44a.48.48 0 0 0-.48-.48h-.48V2H5.85v.96h-.48a.48.48 0 0 0-.48.48v1.24a4.545 4.545 0 0 0 0 6.64v1.24a.48.48 0 0 0 .48.48h.48V14h4.32v-.96h.48a.48.48 0 0 0 .48-.48v-1.24a4.55 4.55 0 0 0 1.379-2.612l.061.012a.48.48 0 0 0 .48-.48v-.48a.48.48 0 0 0-.48-.48m-2.3 2.662a1.6 1.6 0 0 0-.182-.26L8.747 8.338a.79.79 0 0 0 0-.666c.132-.133.894-.899.965-1a1.2 1.2 0 0 0 .14-.485 1 1 0 0 0-.515.157l-.955.957a.784.784 0 1 0 0 1.408c.163.167.956.974 1.236 1.254a1.5 1.5 0 0 0 .36.276 3.055 3.055 0 1 1 .291-.297" class="cls-1"/></svg>`,
};
export const waveform16X16: {
  name: 'waveform_16_x_16';
  data: string;
} = {
  name: 'waveform_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9.77 11.225c-1.582 0-2.076-1.262-2.512-2.376l-.17-.426a26 26 0 0 1-.218-.595c-.32-.9-.41-1.046-.652-1.046-.24 0-.308.065-.612.88-.088.237-.188.504-.317.801l-.098.238c-.486 1.178-1.037 2.513-2.747 2.513H2V9.221h.444c.318 0 .48-.316.9-1.292l.133-.307c.06-.148.121-.304.181-.457.435-1.116.927-2.382 2.56-2.382 1.59 0 2.063 1.274 2.48 2.398l.168.443q.123.308.221.572c.345.905.427 1.03.684 1.03.259 0 .409-.317.742-1.157q.119-.303.266-.652l.097-.228c.477-1.127 1.016-2.405 2.668-2.412l.444-.002L14 6.782h-.447c-.367 0-.506.245-.994 1.387 0 0-.179.434-.238.584-.433 1.101-.973 2.472-2.55 2.472" class="cls-1"/></svg>`,
};
export const webviCustom16X16: {
  name: 'webvi_custom_16_x_16';
  data: string;
} = {
  name: 'webvi_custom_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m4.089 2.526h-1.868a5.6 5.6 0 0 0-.854-1.712 5.36 5.36 0 0 1 2.722 1.712m-2.722 8.66a5.6 5.6 0 0 0 .854-1.712h1.868a5.36 5.36 0 0 1-2.722 1.712m3.181-2.344h-2.146a11 11 0 0 0 .208-1.187L9.923 10c-.05.294-.106.58-.176.843h-1.51l-1.263.632h2.583C9.145 12.647 8.554 13.368 8 13.368c-.517 0-1.065-.633-1.47-1.672l-.56.28a5 5 0 0 0 .663 1.21 5.36 5.36 0 0 1-2.722-1.712h.317a1 1 0 0 1-.017-.17v-.462h-.76a5.3 5.3 0 0 1-.804-2.526h1.564v-.632H2.646a5.3 5.3 0 0 1 .805-2.526h.759V4.69a1 1 0 0 1 .016-.164h-.316a5.36 5.36 0 0 1 2.722-1.712 5 5 0 0 0-.663 1.207l.56.28c.406-1.037.953-1.67 1.47-1.67.554 0 1.145.722 1.557 1.895H6.98l1.261.632h1.507c.07.263.126.548.176.842l.687.344a11 11 0 0 0-.208-1.186h2.146a5.3 5.3 0 0 1 .804 2.526h-.67a.92.92 0 0 1-.001.632h.671a5.3 5.3 0 0 1-.804 2.526M12.105 8a.33.33 0 0 1-.19.296l-6.598 3.3-.148.036a.327.327 0 0 1-.327-.328V4.69a.327.327 0 0 1 .492-.281l6.595 3.302a.33.33 0 0 1 .176.29" class="cls-1"/></svg>`,
};
export const webviHost16X16: {
  name: 'webvi_host_16_x_16';
  data: string;
} = {
  name: 'webvi_host_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6m4.09 2.526H10.22a5.6 5.6 0 0 0-.854-1.712 5.36 5.36 0 0 1 2.722 1.712m-2.723 8.66a5.6 5.6 0 0 0 .854-1.712h1.868a5.36 5.36 0 0 1-2.722 1.712m3.181-2.344h-2.146a11 11 0 0 0 .208-1.187L9.923 10a10 10 0 0 1-.176.843h-1.51l-1.263.632h2.583C9.145 12.647 8.554 13.368 8 13.368c-.517 0-1.064-.633-1.47-1.672l-.56.28a5 5 0 0 0 .663 1.21 5.36 5.36 0 0 1-2.722-1.712h.317a1 1 0 0 1-.017-.17v-.462h-.76a5.3 5.3 0 0 1-.804-2.526H4.21v-.632H2.647a5.3 5.3 0 0 1 .805-2.526h.759V4.69a1 1 0 0 1 .016-.164h-.316a5.36 5.36 0 0 1 2.722-1.712 5 5 0 0 0-.663 1.207l.56.28c.406-1.037.953-1.67 1.47-1.67.554 0 1.145.722 1.557 1.895H6.98l1.262.632h1.506c.07.263.126.548.176.842l.687.344a11 11 0 0 0-.208-1.186h2.146a5.3 5.3 0 0 1 .804 2.526h-.67a.92.92 0 0 1-.001.632h.671a5.3 5.3 0 0 1-.804 2.526m-.619-3.131L5.334 4.409a.327.327 0 0 0-.492.281v6.613a.327.327 0 0 0 .327.328l.148-.035 6.598-3.3a.326.326 0 0 0 .014-.585m-6.087 2.505V5.78L10.274 8Z" class="cls-1"/></svg>`,
};
export const windowCode16X16: {
  name: 'window_code_16_x_16';
  data: string;
} = {
  name: 'window_code_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v12h12V2Zm11 11H3V5h10ZM4 9.135l2.698-1.118v.75l-1.588.65 1.588.646v.75l-2.694-1.12Zm4.42-1.49h.792l-1.565 3.71h-.783ZM12 9.135v.557l-2.694 1.12v-.75l.062-.024 1.526-.626-1.588-.648v-.747Z" class="cls-1"/></svg>`,
};
export const windowText16X16: {
  name: 'window_text_16_x_16';
  data: string;
} = {
  name: 'window_text_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2v12h12V2Zm11 11H3V5h10ZM7 8H4V6h3Zm5 2H4V9h8Zm0 2H4v-1h8Z" class="cls-1"/></svg>`,
};
export const wrenchHammer16X16: {
  name: 'wrench_hammer_16_x_16';
  data: string;
} = {
  name: 'wrench_hammer_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m12.286 11.714-5.791-5.79a2.5 2.5 0 0 0 .17-.755 2.2 2.2 0 0 0-.095-.814 2.1 2.1 0 0 0-.55-.904 2.33 2.33 0 0 0-1.76-.685h-.045a2.1 2.1 0 0 0-.718.155l1.102 1.104.32.32.244.245a1.86 1.86 0 0 1-.22.854 1 1 0 0 1-.114.145 1.65 1.65 0 0 1-1.003.335L2.61 4.704l-.449-.449a2 2 0 0 0-.135.545l-.015.105a2.34 2.34 0 0 0 .384 1.518 2.5 2.5 0 0 0 .295.36 2.2 2.2 0 0 0 1.576.65 2.5 2.5 0 0 0 .898-.175l4.793 4.796 1.203 1.2h.668l.663-.665v-.67ZM5.75 8.908l1.367 1.367-2.988 2.987h-.923l-.45-.45v-.916ZM14 5.906l-1.81 1.809-1.298-1.216-1.38 1.38-1.367-1.365 1.374-1.382-1.622-1.62.683-.774 2.252.45Z" class="cls-1"/></svg>`,
};
export const xmark16X16: {
  name: 'xmark_16_x_16';
  data: string;
} = {
  name: 'xmark_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 4.667 9.667 7.999 13 11.333 11.333 13 8 9.667 4.667 13 3 11.333 6.333 8 3 4.667 4.667 3 8 6.333 11.333 3Z" class="cls-1"/></svg>`,
};
export const xmarkCheck16X16: {
  name: 'xmark_check_16_x_16';
  data: string;
} = {
  name: 'xmark_check_16_x_16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.033 14.026 4.9 10.866 6.277 9.53l1.744 1.81 4.562-4.507 1.307 1.363Zm1.155-10.68-1.321-1.32-2.312 2.311-2.311-2.311-1.321 1.32 2.311 2.312L1.923 7.97l1.32 1.32 2.312-2.31 2.312 2.31 1.32-1.32-2.31-2.312Z" class="cls-1"/></svg>`,
};
export type NimbleIconName =
  | 'add_16_x_16'
  | 'arrow_down_16_x_16'
  | 'arrow_down_left_and_arrow_up_right_16_x_16'
  | 'arrow_down_rectangle_16_x_16'
  | 'arrow_down_right_and_arrow_up_left_16_x_16'
  | 'arrow_expander_down_16_x_16'
  | 'arrow_expander_left_16_x_16'
  | 'arrow_expander_right_16_x_16'
  | 'arrow_expander_up_16_x_16'
  | 'arrow_in_circle_16_x_16'
  | 'arrow_left_from_line_16_x_16'
  | 'arrow_out_circle_16_x_16'
  | 'arrow_partial_rotate_left_16_x_16'
  | 'arrow_right_thin_16_x_16'
  | 'arrow_right_to_line_16_x_16'
  | 'arrow_rotate_right_16_x_16'
  | 'arrow_u_left_16_x_16'
  | 'arrow_u_right_16_x_16'
  | 'arrow_u_up_16_x_16'
  | 'arrow_up_16_x_16'
  | 'arrow_up_left_and_arrow_down_right_16_x_16'
  | 'arrow_up_rectangle_16_x_16'
  | 'arrow_up_right_and_arrow_down_left_16_x_16'
  | 'arrow_up_right_from_square_16_x_16'
  | 'arrows_maximize_16_x_16'
  | 'arrows_repeat_16_x_16'
  | 'asterisk_5_x_5'
  | 'at_16_x_16'
  | 'bars_16_x_16'
  | 'bell_16_x_16'
  | 'bell_and_comment_16_x_16'
  | 'bell_check_16_x_16'
  | 'bell_circle_16_x_16'
  | 'bell_on_16_x_16'
  | 'bell_solid_circle_16_x_16'
  | 'block_with_ribbon_16_x_16'
  | 'bold_b_16_x_16'
  | 'book_magnifying_glass_16_x_16'
  | 'calendar_check_lines_16_x_16'
  | 'calendar_clock_16_x_16'
  | 'calendar_day_16_x_16'
  | 'calendar_day_outline_16_x_16'
  | 'calendar_days_16_x_16'
  | 'calendar_lines_16_x_16'
  | 'calendar_rectangle_16_x_16'
  | 'calendar_week_16_x_16'
  | 'chart_diagram_16_x_16'
  | 'chart_diagram_child_focus_16_x_16'
  | 'chart_diagram_parent_focus_16_x_16'
  | 'chart_diagram_parent_focus_two_child_16_x_16'
  | 'check_16_x_16'
  | 'check_dot_16_x_16'
  | 'circle_16_x_16'
  | 'circle_filled_16_x_16'
  | 'circle_broken_16_x_16'
  | 'circle_check_16_x_16'
  | 'circle_minus_16_x_16'
  | 'circle_partial_broken_16_x_16'
  | 'circle_slash_16_x_16'
  | 'circle_x_16_x_16'
  | 'clipboard_16_x_16'
  | 'clock_16_x_16'
  | 'clock_cog_16_x_16'
  | 'clock_exclamation_16_x_16'
  | 'clock_triangle_16_x_16'
  | 'clone_16_x_16'
  | 'cloud_16_x_16'
  | 'cloud_upload_16_x_16'
  | 'cloud_with_arrow_16_x_16'
  | 'cog_16_x_16'
  | 'cog_database_16_x_16'
  | 'cog_database_inset_16_x_16'
  | 'cog_small_cog_16_x_16'
  | 'cog_zoomed_16_x_16'
  | 'comment_16_x_16'
  | 'computer_and_monitor_16_x_16'
  | 'copy_16_x_16'
  | 'copy_text_16_x_16'
  | 'dashboard_builder_16_x_16'
  | 'dashboard_builder_legend_16_x_16'
  | 'dashboard_builder_templates_16_x_16'
  | 'dashboard_builder_tile_16_x_16'
  | 'database_16_x_16'
  | 'database_check_16_x_16'
  | 'debug_16_x_16'
  | 'desktop_16_x_16'
  | 'donut_chart_16_x_16'
  | 'dot_solid_dot_stroke_16_x_16'
  | 'dot_solid_dot_stroke_measurement_16_x_16'
  | 'down_right_from_square_16_x_16'
  | 'download_16_x_16'
  | 'electronic_chip_zoomed_16_x_16'
  | 'exclamation_mark_16_x_16'
  | 'eye_16_x_16'
  | 'eye_dash_16_x_16'
  | 'fancy_a_16_x_16'
  | 'file_16_x_16'
  | 'file_arrow_curved_right_16_x_16'
  | 'file_drawer_16_x_16'
  | 'file_search_16_x_16'
  | 'filter_16_x_16'
  | 'floppy_disk_16_x_16'
  | 'floppy_disk_checkmark_16_x_16'
  | 'floppy_disk_pen_16_x_16'
  | 'floppy_disk_star_arrow_right_16_x_16'
  | 'floppy_disk_three_dots_16_x_16'
  | 'folder_16_x_16'
  | 'folder_open_16_x_16'
  | 'forward_slash_16_x_16'
  | 'four_dots_square_16_x_16'
  | 'function_16_x_16'
  | 'gauge_simple_16_x_16'
  | 'grid_three_by_three_16_x_16'
  | 'grid_two_by_two_16_x_16'
  | 'hammer_16_x_16'
  | 'hashtag_16_x_16'
  | 'home_16_x_16'
  | 'horizontal_triangle_outline_16_x_16'
  | 'hourglass_16_x_16'
  | 'indent_16_x_16'
  | 'indeterminant_checkbox_16_x_16'
  | 'info_16_x_16'
  | 'info_circle_16_x_16'
  | 'inward_squares_three_16_x_16'
  | 'italic_i_16_x_16'
  | 'key_16_x_16'
  | 'laptop_16_x_16'
  | 'layer_group_16_x_16'
  | 'lightbulb_16_x_16'
  | 'lightning_bolt_16_x_16'
  | 'link_16_x_16'
  | 'link_cancel_16_x_16'
  | 'list_16_x_16'
  | 'list_tree_16_x_16'
  | 'list_tree_database_16_x_16'
  | 'lock_16_x_16'
  | 'magnifying_glass_16_x_16'
  | 'markdown_16_x_16'
  | 'message_bot_16_x_16'
  | 'microphone_16_x_16'
  | 'minus_16_x_16'
  | 'minus_wide_16_x_16'
  | 'mobile_16_x_16'
  | 'mountain_sun_16_x_16'
  | 'ni_16_x_16'
  | 'notebook_16_x_16'
  | 'number_list_16_x_16'
  | 'outdent_16_x_16'
  | 'outward_squares_three_16_x_16'
  | 'paper_plane_16_x_16'
  | 'paperclip_16_x_16'
  | 'paste_16_x_16'
  | 'pause_16_x_16'
  | 'pencil_16_x_16'
  | 'play'
  | 'pot_with_lid_16_x_16'
  | 'question_16_x_16'
  | 'rectangle_check_lines_16_x_16'
  | 'rectangle_lines_16_x_16'
  | 'running_arrow_16_x_16'
  | 'screen_check_lines_16_x_16'
  | 'screen_check_lines_calendar_16_x_16'
  | 'server_16_x_16'
  | 'share_nodes_16_x_16'
  | 'shield_check_16_x_16'
  | 'shield_xmark_16_x_16'
  | 'signal_bars_16_x_16'
  | 'sine_graph_16_x_16'
  | 'skip_arrow_16_x_16'
  | 'sparkle_swirls_16_x_16'
  | 'sparkles_16_x_16'
  | 'spinner'
  | 'square_check_16_x_16'
  | 'square_t_16_x_16'
  | 'square_x_16_x_16'
  | 'star_8_point_16_x_16'
  | 'stop_square_16_x_16'
  | 'systemlink_16_x_16'
  | 't_16_x_16'
  | 'tablet_16_x_16'
  | 'tag_16_x_16'
  | 'tags_16_x_16'
  | 'target_crosshairs_16_x_16'
  | 'target_crosshairs_progress_16_x_16'
  | 'three_circles_ascending_container_16_x_16'
  | 'three_dots_line_16_x_16'
  | 'three_vertical_lines_16_x_16'
  | 'thumb_down_16_x_16'
  | 'thumb_up_16_x_16'
  | 'thumbtack_16_x_16'
  | 'tile_size_16_x_16'
  | 'times_16_x_16'
  | 'trash_16_x_16'
  | 'triangle_16_x_16'
  | 'triangle_filled_16_x_16'
  | 'triangle_two_lines_horizontal'
  | 'true_false_rectangle_16_x_16'
  | 'two_squares_in_brackets'
  | 'two_triangles_between_lines'
  | 'unlink_16_x_16'
  | 'unlock_16_x_16'
  | 'up_right_from_square_16_x_16'
  | 'upload_16_x_16'
  | 'user_16_x_16'
  | 'watch_16_x_16'
  | 'waveform_16_x_16'
  | 'webvi_custom_16_x_16'
  | 'webvi_host_16_x_16'
  | 'window_code_16_x_16'
  | 'window_text_16_x_16'
  | 'wrench_hammer_16_x_16'
  | 'xmark_16_x_16'
  | 'xmark_check_16_x_16';
export interface NimbleIcon {
  name: NimbleIconName;
  data: string;
}
export type NimbleIconNameSubset<T extends Readonly<NimbleIcon[]>> =
  T[number]['name'];
